import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: string; output: string };
  Decimal: { input: number; output: number };
  UUID: { input: string; output: string };
  UnsignedByte: { input: unknown; output: unknown };
};

/**
 * Represents an accounting document (invoice, credit note, etc.).
 * Once a document leaves Draft state it is immutable: no update mutation may modify it and no delete
 * mutation may ever be exposed. Number must be globally unique and sequential; never reassigned or reused.
 */
export type AccountingDocument = {
  __typename: 'AccountingDocument';
  /**
   * All accounting documents related to this one (credit/debit notes applied,
   *             invoices a credit paid, replacement/cancelled pairs). Symmetric: both docs see each other.
   *             Filter by Type / State to recover role. Link via AccountingDocument).
   */
  accountingDocuments: Array<AccountingDocument>;
  /**
   * Provider-agnostic free-form metadata (reseller audit, etc.). Stored as jsonb for
   * efficient JSON operator queries. Keys consumed today: ResellerTenantId.
   */
  additionalPropertiesJson: Maybe<Scalars['String']['output']>;
  /** Frozen buyer+seller snapshot written at Sent-time; re-renders read from here. */
  addressesSnapshotJson: Maybe<Scalars['String']['output']>;
  amountGross: Scalars['Decimal']['output'];
  amountNet: Scalars['Decimal']['output'];
  /** Frozen coupon reference at invoice create. Discount amounts live on discounted lines. */
  couponSnapshotJson: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currencyCode: Scalars['String']['output'];
  documentFooter: Maybe<Scalars['String']['output']>;
  documentHeader: Maybe<Scalars['String']['output']>;
  /** Calculated from CreatedAt + PaymentTerm.Days at invoice creation. */
  dueDate: Maybe<Scalars['DateTime']['output']>;
  employeeReference: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  items: Array<AccountingDocumentItem>;
  /** Globally unique sequential invoice number: {InvoicePrefix from AppSettings}{YY}{counter}, counter from last invoice (start 10000). Set at creation only. */
  number: Scalars['String']['output'];
  organizationUnit: Maybe<OrganizationUnit>;
  /**
   * Recipient OU for one-time / quote-flipped invoices. Null on sub-cycle invoices, where the
   * recipient is read via Subscription.OrganizationUnit.
   * Set at PayQuote time for quotes (customer picks their own OU; reseller has no access).
   */
  organizationUnitId: Maybe<Scalars['UUID']['output']>;
  paymentAccountSnapshotJson: Maybe<Scalars['String']['output']>;
  payments: Array<Payment>;
  pdfDataBase64: Maybe<Scalars['String']['output']>;
  privateNotice: Maybe<Scalars['String']['output']>;
  /** Eligible for reseller commission payout. Stays true after payout; open = null ProvisionCreditNoteId. */
  provisionActive: Scalars['Boolean']['output'];
  provisionCreditNote: Maybe<AccountingDocument>;
  /** Batch payout credit note that included this document. */
  provisionCreditNoteId: Maybe<Scalars['UUID']['output']>;
  publicNotice: Maybe<Scalars['String']['output']>;
  /**
   * Reseller's TenantId at issue time. Doubles as the "reseller-created" sentinel:
   * presence triggers the customer-tenant swap on PayQuote / webhook auto-bill.
   * Stored inside AdditionalPropertiesJson.
   */
  resellerTenantId: Maybe<Scalars['UUID']['output']>;
  sentAt: Maybe<Scalars['DateTime']['output']>;
  state: AccountingDocumentState;
  subscription: Maybe<Subscription>;
  subscriptionId: Maybe<Scalars['UUID']['output']>;
  taxAmount: Scalars['Decimal']['output'];
  tenant: Tenant;
  tenantId: Scalars['UUID']['output'];
  type: AccountingDocumentType;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Standalone XRechnung CII XML. ZUGFeRD CII is embedded inside PdfData. */
  xmlData: Maybe<Array<Scalars['UnsignedByte']['output']>>;
  xmlDataBase64: Maybe<Scalars['String']['output']>;
};

/**
 * Represents an accounting document (invoice, credit note, etc.).
 * Once a document leaves Draft state it is immutable: no update mutation may modify it and no delete
 * mutation may ever be exposed. Number must be globally unique and sequential; never reassigned or reused.
 */
export type AccountingDocumentFilterInput = {
  /**
   * All accounting documents related to this one (credit/debit notes applied,
   *             invoices a credit paid, replacement/cancelled pairs). Symmetric: both docs see each other.
   *             Filter by Type / State to recover role. Link via AccountingDocument).
   */
  accountingDocuments?: InputMaybe<ListFilterInputTypeOfAccountingDocumentFilterInput>;
  /**
   * Provider-agnostic free-form metadata (reseller audit, etc.). Stored as jsonb for
   * efficient JSON operator queries. Keys consumed today: ResellerTenantId.
   */
  additionalPropertiesJson?: InputMaybe<StringOperationFilterInput>;
  /** Frozen buyer+seller snapshot written at Sent-time; re-renders read from here. */
  addressesSnapshotJson?: InputMaybe<StringOperationFilterInput>;
  amountGross?: InputMaybe<DecimalOperationFilterInput>;
  amountNet?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<AccountingDocumentFilterInput>>;
  /** Frozen coupon reference at invoice create. Discount amounts live on discounted lines. */
  couponSnapshotJson?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  currencyCode?: InputMaybe<StringOperationFilterInput>;
  documentFooter?: InputMaybe<StringOperationFilterInput>;
  documentHeader?: InputMaybe<StringOperationFilterInput>;
  /** Calculated from CreatedAt + PaymentTerm.Days at invoice creation. */
  dueDate?: InputMaybe<DateTimeOperationFilterInput>;
  employeeReference?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfAccountingDocumentItemFilterInput>;
  /** Globally unique sequential invoice number: {InvoicePrefix from AppSettings}{YY}{counter}, counter from last invoice (start 10000). Set at creation only. */
  number?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AccountingDocumentFilterInput>>;
  organizationUnit?: InputMaybe<OrganizationUnitFilterInput>;
  /**
   * Recipient OU for one-time / quote-flipped invoices. Null on sub-cycle invoices, where the
   * recipient is read via Subscription.OrganizationUnit.
   * Set at PayQuote time for quotes (customer picks their own OU; reseller has no access).
   */
  organizationUnitId?: InputMaybe<UuidOperationFilterInput>;
  paymentAccountSnapshotJson?: InputMaybe<StringOperationFilterInput>;
  payments?: InputMaybe<ListFilterInputTypeOfPaymentFilterInput>;
  pdfDataBase64?: InputMaybe<StringOperationFilterInput>;
  privateNotice?: InputMaybe<StringOperationFilterInput>;
  /** Eligible for reseller commission payout. Stays true after payout; open = null ProvisionCreditNoteId. */
  provisionActive?: InputMaybe<BooleanOperationFilterInput>;
  provisionCreditNote?: InputMaybe<AccountingDocumentFilterInput>;
  /** Batch payout credit note that included this document. */
  provisionCreditNoteId?: InputMaybe<UuidOperationFilterInput>;
  publicNotice?: InputMaybe<StringOperationFilterInput>;
  /**
   * Reseller's TenantId at issue time. Doubles as the "reseller-created" sentinel:
   * presence triggers the customer-tenant swap on PayQuote / webhook auto-bill.
   * Stored inside AdditionalPropertiesJson.
   */
  resellerTenantId?: InputMaybe<UuidOperationFilterInput>;
  sentAt?: InputMaybe<DateTimeOperationFilterInput>;
  state?: InputMaybe<AccountingDocumentStateOperationFilterInput>;
  subscription?: InputMaybe<SubscriptionFilterInput>;
  subscriptionId?: InputMaybe<UuidOperationFilterInput>;
  taxAmount?: InputMaybe<DecimalOperationFilterInput>;
  tenant?: InputMaybe<TenantFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  type?: InputMaybe<AccountingDocumentTypeOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Standalone XRechnung CII XML. ZUGFeRD CII is embedded inside PdfData. */
  xmlData?: InputMaybe<ListUnsignedByteOperationFilterInput>;
  xmlDataBase64?: InputMaybe<StringOperationFilterInput>;
};

/** Represents a line item in an accounting document. */
export type AccountingDocumentItem = {
  __typename: 'AccountingDocumentItem';
  accountingDocument: AccountingDocument;
  accountingDocumentId: Scalars['UUID']['output'];
  amountGross: Scalars['Decimal']['output'];
  amountNet: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  orderPosition: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  taxRule: TaxRule;
  taxRuleId: Scalars['UUID']['output'];
  taxSnapshotJson: Maybe<Scalars['String']['output']>;
  unitPriceGross: Scalars['Decimal']['output'];
  unitPriceNet: Scalars['Decimal']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Represents a line item in an accounting document. */
export type AccountingDocumentItemFilterInput = {
  accountingDocument?: InputMaybe<AccountingDocumentFilterInput>;
  accountingDocumentId?: InputMaybe<UuidOperationFilterInput>;
  amountGross?: InputMaybe<DecimalOperationFilterInput>;
  amountNet?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<AccountingDocumentItemFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AccountingDocumentItemFilterInput>>;
  orderPosition?: InputMaybe<IntOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  taxRule?: InputMaybe<TaxRuleFilterInput>;
  taxRuleId?: InputMaybe<UuidOperationFilterInput>;
  taxSnapshotJson?: InputMaybe<StringOperationFilterInput>;
  unitPriceGross?: InputMaybe<DecimalOperationFilterInput>;
  unitPriceNet?: InputMaybe<DecimalOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * Represents an accounting document (invoice, credit note, etc.).
 * Once a document leaves Draft state it is immutable: no update mutation may modify it and no delete
 * mutation may ever be exposed. Number must be globally unique and sequential; never reassigned or reused.
 */
export type AccountingDocumentSortInput = {
  /**
   * Provider-agnostic free-form metadata (reseller audit, etc.). Stored as jsonb for
   * efficient JSON operator queries. Keys consumed today: ResellerTenantId.
   */
  additionalPropertiesJson?: InputMaybe<SortEnumType>;
  /** Frozen buyer+seller snapshot written at Sent-time; re-renders read from here. */
  addressesSnapshotJson?: InputMaybe<SortEnumType>;
  amountGross?: InputMaybe<SortEnumType>;
  amountNet?: InputMaybe<SortEnumType>;
  /** Frozen coupon reference at invoice create. Discount amounts live on discounted lines. */
  couponSnapshotJson?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  currencyCode?: InputMaybe<SortEnumType>;
  documentFooter?: InputMaybe<SortEnumType>;
  documentHeader?: InputMaybe<SortEnumType>;
  /** Calculated from CreatedAt + PaymentTerm.Days at invoice creation. */
  dueDate?: InputMaybe<SortEnumType>;
  employeeReference?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** Globally unique sequential invoice number: {InvoicePrefix from AppSettings}{YY}{counter}, counter from last invoice (start 10000). Set at creation only. */
  number?: InputMaybe<SortEnumType>;
  organizationUnit?: InputMaybe<OrganizationUnitSortInput>;
  /**
   * Recipient OU for one-time / quote-flipped invoices. Null on sub-cycle invoices, where the
   * recipient is read via Subscription.OrganizationUnit.
   * Set at PayQuote time for quotes (customer picks their own OU; reseller has no access).
   */
  organizationUnitId?: InputMaybe<SortEnumType>;
  paymentAccountSnapshotJson?: InputMaybe<SortEnumType>;
  pdfDataBase64?: InputMaybe<SortEnumType>;
  privateNotice?: InputMaybe<SortEnumType>;
  /** Eligible for reseller commission payout. Stays true after payout; open = null ProvisionCreditNoteId. */
  provisionActive?: InputMaybe<SortEnumType>;
  provisionCreditNote?: InputMaybe<AccountingDocumentSortInput>;
  /** Batch payout credit note that included this document. */
  provisionCreditNoteId?: InputMaybe<SortEnumType>;
  publicNotice?: InputMaybe<SortEnumType>;
  /**
   * Reseller's TenantId at issue time. Doubles as the "reseller-created" sentinel:
   * presence triggers the customer-tenant swap on PayQuote / webhook auto-bill.
   * Stored inside AdditionalPropertiesJson.
   */
  resellerTenantId?: InputMaybe<SortEnumType>;
  sentAt?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  subscription?: InputMaybe<SubscriptionSortInput>;
  subscriptionId?: InputMaybe<SortEnumType>;
  taxAmount?: InputMaybe<SortEnumType>;
  tenant?: InputMaybe<TenantSortInput>;
  tenantId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  xmlDataBase64?: InputMaybe<SortEnumType>;
};

/** Represents the state of an accounting document. */
export type AccountingDocumentState = 'CANCELLED' | 'DRAFT' | 'OVERDUE' | 'PAID' | 'SENT';

export type AccountingDocumentStateOperationFilterInput = {
  eq?: InputMaybe<AccountingDocumentState>;
  in?: InputMaybe<Array<AccountingDocumentState>>;
  neq?: InputMaybe<AccountingDocumentState>;
  nin?: InputMaybe<Array<AccountingDocumentState>>;
};

/** Represents the type of an accounting document. */
export type AccountingDocumentType =
  | 'CREDIT_NOTE'
  /** Post-invoice charge (DE: Belastungsanzeige). Example: used for failed-payment fees. */
  | 'DEBIT_NOTE'
  | 'INVOICE'
  /**
   * Pre-payment offer. Number holds the quote
   * reference (QUOTE-...) until payment, at which point Type flips to Invoice and
   * Number is overwritten with the gapless invoice sequence.
   */
  | 'QUOTE'
  | 'RECEIPT';

export type AccountingDocumentTypeOperationFilterInput = {
  eq?: InputMaybe<AccountingDocumentType>;
  in?: InputMaybe<Array<AccountingDocumentType>>;
  neq?: InputMaybe<AccountingDocumentType>;
  nin?: InputMaybe<Array<AccountingDocumentType>>;
};

/** A connection to a list of items. */
export type AccountingDocumentsConnection = {
  __typename: 'AccountingDocumentsConnection';
  /** A list of edges. */
  edges: Maybe<Array<AccountingDocumentsEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<AccountingDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AccountingDocumentsEdge = {
  __typename: 'AccountingDocumentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AccountingDocument;
};

/** Represents the type of an organization address. */
export type AddressType =
  /** Physical branch/location address. */
  | 'BRANCH'
  /** Customer Contact Address for Resellers. */
  | 'CUSTOMER_CONTACT'
  /** Delivery/shipping address. */
  | 'DELIVERY'
  /** Headquarters/main office address. */
  | 'HEADQUARTERS'
  /** Invoice/billing address. */
  | 'INVOICE'
  /** Other address type. */
  | 'OTHER';

export type AddressTypeOperationFilterInput = {
  eq?: InputMaybe<AddressType>;
  in?: InputMaybe<Array<AddressType>>;
  neq?: InputMaybe<AddressType>;
  nin?: InputMaybe<Array<AddressType>>;
};

/** Represents the application type. */
export type AppType =
  /** Hospitality application. */
  | 'HOSPITALITY'
  /** Point of Sale application. */
  | 'POS'
  /** Retail application. */
  | 'RETAIL';

export type AppTypeOperationFilterInput = {
  eq?: InputMaybe<AppType>;
  in?: InputMaybe<Array<AppType>>;
  neq?: InputMaybe<AppType>;
  nin?: InputMaybe<Array<AppType>>;
};

/** Represents a published POS app version and its release notes (German). */
export type AppVersion = {
  __typename: 'AppVersion';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  releaseDate: Scalars['DateTime']['output'];
  /** Release notes in German (plain text or markdown). */
  releaseNotes: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Android versionCode. */
  versionCode: Scalars['Int']['output'];
  /** Semantic version, e.g. 9.1.0 */
  versionName: Scalars['String']['output'];
};

/** Represents a published POS app version and its release notes (German). */
export type AppVersionFilterInput = {
  and?: InputMaybe<Array<AppVersionFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<AppVersionFilterInput>>;
  releaseDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Release notes in German (plain text or markdown). */
  releaseNotes?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Android versionCode. */
  versionCode?: InputMaybe<IntOperationFilterInput>;
  /** Semantic version, e.g. 9.1.0 */
  versionName?: InputMaybe<StringOperationFilterInput>;
};

/** Global app version thresholds and store link from app_settings. */
export type AppVersionPolicy = {
  __typename: 'AppVersionPolicy';
  requiredMinVersion: Maybe<Scalars['String']['output']>;
  suggestedMinVersion: Maybe<Scalars['String']['output']>;
  updateStoreUrl: Maybe<Scalars['String']['output']>;
};

/** Represents a published POS app version and its release notes (German). */
export type AppVersionSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  releaseDate?: InputMaybe<SortEnumType>;
  /** Release notes in German (plain text or markdown). */
  releaseNotes?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  /** Android versionCode. */
  versionCode?: InputMaybe<SortEnumType>;
  /** Semantic version, e.g. 9.1.0 */
  versionName?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AppVersionsConnection = {
  __typename: 'AppVersionsConnection';
  /** A list of edges. */
  edges: Maybe<Array<AppVersionsEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<AppVersion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AppVersionsEdge = {
  __typename: 'AppVersionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AppVersion;
};

export type ApplyCouponToSubscriptionError =
  | CouponExpiredError
  | CouponInactiveError
  | CouponMaxRedemptionsError
  | CouponNotApplicableError
  | CouponNotFoundError
  | EntityNotFoundError;

export type ApplyCouponToSubscriptionInput = {
  couponCode: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
};

export type ApplyCouponToSubscriptionPayload = {
  __typename: 'ApplyCouponToSubscriptionPayload';
  errors: Maybe<Array<ApplyCouponToSubscriptionError>>;
  subscription: Maybe<Subscription>;
};

/** Defines when a policy shall be executed. */
export type ApplyPolicy =
  /** After the resolver was executed. */
  | 'AFTER_RESOLVER'
  /** Before the resolver was executed. */
  | 'BEFORE_RESOLVER'
  /** The policy is applied in the validation step before the execution. */
  | 'VALIDATION';

/** A connection to a list of items. */
export type AvailableCouponsConnection = {
  __typename: 'AvailableCouponsConnection';
  /** A list of edges. */
  edges: Maybe<Array<AvailableCouponsEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<Coupon>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AvailableCouponsEdge = {
  __typename: 'AvailableCouponsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Coupon;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CancelSubscriptionError = EntityNotFoundError | InvalidStateTransitionError;

export type CancelSubscriptionInput = {
  id: Scalars['UUID']['input'];
};

export type CancelSubscriptionPayload = {
  __typename: 'CancelSubscriptionPayload';
  errors: Maybe<Array<CancelSubscriptionError>>;
  subscription: Maybe<Subscription>;
};

export type CheckoutResult = {
  __typename: 'CheckoutResult';
  amountGross: Scalars['Decimal']['output'];
  currencyCode: Scalars['String']['output'];
  orderId: Scalars['UUID']['output'];
  sessionData: Maybe<Scalars['String']['output']>;
  sessionId: Maybe<Scalars['String']['output']>;
};

export type CompleteInvitationPayload = {
  __typename: 'CompleteInvitationPayload';
  invitation: Maybe<Invitation>;
};

export type ConfirmOrderError = EntityNotFoundError | InvalidStateTransitionError;

export type ConfirmOrderInput = {
  orderId: Scalars['UUID']['input'];
  paymentAccountId?: InputMaybe<Scalars['UUID']['input']>;
  sessionResult?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmOrderPayload = {
  __typename: 'ConfirmOrderPayload';
  errors: Maybe<Array<ConfirmOrderError>>;
  uuid: Maybe<Scalars['UUID']['output']>;
};

/** Promotional coupon for subscription discounts. Pricing fields immutable after create. */
export type Coupon = {
  __typename: 'Coupon';
  allowedPlanCodes: Array<Scalars['String']['output']>;
  allowedProductSkus: Array<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  discountType: CouponDiscountType;
  discountValue: Scalars['Decimal']['output'];
  duration: Maybe<Scalars['Int']['output']>;
  expiryDate: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  maxRedemptions: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  redemptionCount: Scalars['Int']['output'];
  status: CouponStatus;
  type: CouponType;
  updatedAt: Scalars['DateTime']['output'];
  usageType: CouponUsageType;
};

export type CouponDiscountType = 'FLAT' | 'PERCENTAGE';

export type CouponDiscountTypeOperationFilterInput = {
  eq?: InputMaybe<CouponDiscountType>;
  in?: InputMaybe<Array<CouponDiscountType>>;
  neq?: InputMaybe<CouponDiscountType>;
  nin?: InputMaybe<Array<CouponDiscountType>>;
};

export type CouponExpiredError = Error & {
  __typename: 'CouponExpiredError';
  message: Scalars['String']['output'];
};

/** Promotional coupon for subscription discounts. Pricing fields immutable after create. */
export type CouponFilterInput = {
  allowedPlanCodes?: InputMaybe<ListStringOperationFilterInput>;
  allowedProductSkus?: InputMaybe<ListStringOperationFilterInput>;
  and?: InputMaybe<Array<CouponFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  discountType?: InputMaybe<CouponDiscountTypeOperationFilterInput>;
  discountValue?: InputMaybe<DecimalOperationFilterInput>;
  duration?: InputMaybe<IntOperationFilterInput>;
  expiryDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  maxRedemptions?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CouponFilterInput>>;
  redemptionCount?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<CouponStatusOperationFilterInput>;
  type?: InputMaybe<CouponTypeOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  usageType?: InputMaybe<CouponUsageTypeOperationFilterInput>;
};

export type CouponInactiveError = Error & {
  __typename: 'CouponInactiveError';
  message: Scalars['String']['output'];
};

export type CouponMaxRedemptionsError = Error & {
  __typename: 'CouponMaxRedemptionsError';
  message: Scalars['String']['output'];
};

export type CouponNotApplicableError = Error & {
  __typename: 'CouponNotApplicableError';
  message: Scalars['String']['output'];
};

export type CouponNotFoundError = Error & {
  __typename: 'CouponNotFoundError';
  message: Scalars['String']['output'];
};

/** Promotional coupon for subscription discounts. Pricing fields immutable after create. */
export type CouponSortInput = {
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  discountType?: InputMaybe<SortEnumType>;
  discountValue?: InputMaybe<SortEnumType>;
  duration?: InputMaybe<SortEnumType>;
  expiryDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  maxRedemptions?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  redemptionCount?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  usageType?: InputMaybe<SortEnumType>;
};

export type CouponStatus = 'ACTIVE' | 'INACTIVE';

export type CouponStatusOperationFilterInput = {
  eq?: InputMaybe<CouponStatus>;
  in?: InputMaybe<Array<CouponStatus>>;
  neq?: InputMaybe<CouponStatus>;
  nin?: InputMaybe<Array<CouponStatus>>;
};

/** How many billing cycles a coupon discount applies per subscription. */
export type CouponType = 'DURATION' | 'FOREVER' | 'ONE_TIME';

export type CouponTypeOperationFilterInput = {
  eq?: InputMaybe<CouponType>;
  in?: InputMaybe<Array<CouponType>>;
  neq?: InputMaybe<CouponType>;
  nin?: InputMaybe<Array<CouponType>>;
};

/** Whether a coupon is publicly known to resellers/customers, or internal-only. */
export type CouponUsageType = 'INTERNAL' | 'RESELLER';

export type CouponUsageTypeOperationFilterInput = {
  eq?: InputMaybe<CouponUsageType>;
  in?: InputMaybe<Array<CouponUsageType>>;
  neq?: InputMaybe<CouponUsageType>;
  nin?: InputMaybe<Array<CouponUsageType>>;
};

/** A connection to a list of items. */
export type CouponsConnection = {
  __typename: 'CouponsConnection';
  /** A list of edges. */
  edges: Maybe<Array<CouponsEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<Coupon>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CouponsEdge = {
  __typename: 'CouponsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Coupon;
};

export type CreateAppVersionInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseDate: Scalars['DateTime']['input'];
  releaseNotes: Scalars['String']['input'];
  versionCode: Scalars['Int']['input'];
  versionName: Scalars['String']['input'];
};

export type CreateAppVersionPayload = {
  __typename: 'CreateAppVersionPayload';
  appVersion: Maybe<AppVersion>;
};

export type CreateCouponInput = {
  allowedPlanCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedProductSkus?: InputMaybe<Array<Scalars['String']['input']>>;
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  discountType: CouponDiscountType;
  discountValue: Scalars['Decimal']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  status: CouponStatus;
  type: CouponType;
  usageType: CouponUsageType;
};

export type CreateCouponPayload = {
  __typename: 'CreateCouponPayload';
  coupon: Maybe<Coupon>;
};

export type CreateInvitationInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  recipientEmail: Scalars['String']['input'];
  recipientName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInvitationPayload = {
  __typename: 'CreateInvitationPayload';
  invitation: Maybe<Invitation>;
};

export type CreateOrderError = EntityNotFoundError;

export type CreateOrderInput = {
  countryCode: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  items: Array<SubscriptionSkuLineInput>;
  organizationUnitId: Scalars['UUID']['input'];
  paymentAccountId?: InputMaybe<Scalars['UUID']['input']>;
  paymentGatewayId: Scalars['UUID']['input'];
  planId: Scalars['UUID']['input'];
  redirectUri: Scalars['String']['input'];
  taxRuleId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateOrderPayload = {
  __typename: 'CreateOrderPayload';
  checkoutResult: Maybe<CheckoutResult>;
  errors: Maybe<Array<CreateOrderError>>;
};

export type CreateOrganizationAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isDefault: Scalars['Boolean']['input'];
  organizationId: Scalars['UUID']['input'];
  organizationUnitId?: InputMaybe<Scalars['UUID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  type: AddressType;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrganizationAddressPayload = {
  __typename: 'CreateOrganizationAddressPayload';
  organizationAddress: Maybe<OrganizationAddress>;
};

export type CreateOrganizationContactError = EntityNotFoundError;

export type CreateOrganizationContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['UUID']['input'];
  position?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrganizationContactPayload = {
  __typename: 'CreateOrganizationContactPayload';
  errors: Maybe<Array<CreateOrganizationContactError>>;
  organizationContact: Maybe<OrganizationContact>;
};

export type CreateOrganizationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrganizationPayload = {
  __typename: 'CreateOrganizationPayload';
  organization: Maybe<Organization>;
};

export type CreateOrganizationUnitInput = {
  appType?: InputMaybe<Scalars['String']['input']>;
  branchType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
};

export type CreateOrganizationUnitPayload = {
  __typename: 'CreateOrganizationUnitPayload';
  organizationUnit: Maybe<OrganizationUnit>;
};

export type CreatePaymentError = EntityNotFoundError | InvalidOperationError;

export type CreatePaymentGatewayInput = {
  isActive: Scalars['Boolean']['input'];
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  provider: Scalars['String']['input'];
};

export type CreatePaymentGatewayPayload = {
  __typename: 'CreatePaymentGatewayPayload';
  paymentGateway: Maybe<PaymentGateway>;
};

export type CreatePaymentInput = {
  accountingDocumentId?: InputMaybe<Scalars['UUID']['input']>;
  amountGross: Scalars['Decimal']['input'];
  amountNet: Scalars['Decimal']['input'];
  currencyCode: Scalars['String']['input'];
  direction: PaymentDirection;
  paymentGatewayId?: InputMaybe<Scalars['UUID']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<PaymentState>;
  tenantId: Scalars['UUID']['input'];
};

export type CreatePaymentPayload = {
  __typename: 'CreatePaymentPayload';
  errors: Maybe<Array<CreatePaymentError>>;
  payment: Maybe<Payment>;
};

export type CreatePaymentTermInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  days: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreatePaymentTermPayload = {
  __typename: 'CreatePaymentTermPayload';
  paymentTerm: Maybe<PaymentTerm>;
};

export type CreatePlanInput = {
  amountGross: Scalars['Decimal']['input'];
  amountNet: Scalars['Decimal']['input'];
  code: Scalars['String']['input'];
  contractTermMonths: Scalars['Int']['input'];
  intervalMonths: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  skus?: InputMaybe<Array<Scalars['String']['input']>>;
  status: PlanStatus;
};

export type CreatePlanPayload = {
  __typename: 'CreatePlanPayload';
  plan: Maybe<Plan>;
};

export type CreateProductInput = {
  longDescription?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  number: Scalars['String']['input'];
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  sort: Scalars['Int']['input'];
  type: ProductType;
};

export type CreateProductPayload = {
  __typename: 'CreateProductPayload';
  product: Maybe<Product>;
};

export type CreateProvisionPayoutError = EntityNotFoundError | InvalidOperationError;

export type CreateProvisionPayoutInput = {
  resellerTenantId: Scalars['UUID']['input'];
};

export type CreateProvisionPayoutPayload = {
  __typename: 'CreateProvisionPayoutPayload';
  accountingDocument: Maybe<AccountingDocument>;
  errors: Maybe<Array<CreateProvisionPayoutError>>;
};

export type CreateResourceError = InvalidOperationError;

export type CreateResourceInput = {
  contentBase64: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type CreateResourcePayload = {
  __typename: 'CreateResourcePayload';
  errors: Maybe<Array<CreateResourceError>>;
  resource: Maybe<Resource>;
};

export type CreateTaxRuleInput = {
  isActive: Scalars['Boolean']['input'];
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  printText?: InputMaybe<Scalars['String']['input']>;
  taxRate: Scalars['Decimal']['input'];
};

export type CreateTaxRulePayload = {
  __typename: 'CreateTaxRulePayload';
  taxRule: Maybe<TaxRule>;
};

export type CreateTrialLicenceError = LicenceAlreadyExistsError;

export type CreateTrialLicenceInput = {
  databaseId: Scalars['UUID']['input'];
  organizationUnitId: Scalars['UUID']['input'];
  terminalId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTrialLicencePayload = {
  __typename: 'CreateTrialLicencePayload';
  errors: Maybe<Array<CreateTrialLicenceError>>;
  licence: Maybe<Licence>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DeleteAppVersionError = EntityNotFoundError | EntityReferencedError;

export type DeleteAppVersionInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteAppVersionPayload = {
  __typename: 'DeleteAppVersionPayload';
  boolean: Maybe<Scalars['Boolean']['output']>;
  errors: Maybe<Array<DeleteAppVersionError>>;
};

export type DeleteCouponError = EntityNotFoundError;

export type DeleteCouponInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteCouponPayload = {
  __typename: 'DeleteCouponPayload';
  boolean: Maybe<Scalars['Boolean']['output']>;
  errors: Maybe<Array<DeleteCouponError>>;
};

export type DeleteMainCouponPayload = {
  __typename: 'DeleteMainCouponPayload';
  boolean: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteOrganizationAddressError = EntityNotFoundError;

export type DeleteOrganizationAddressInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteOrganizationAddressPayload = {
  __typename: 'DeleteOrganizationAddressPayload';
  boolean: Maybe<Scalars['Boolean']['output']>;
  errors: Maybe<Array<DeleteOrganizationAddressError>>;
};

export type DeleteOrganizationContactError = EntityNotFoundError;

export type DeleteOrganizationContactInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteOrganizationContactPayload = {
  __typename: 'DeleteOrganizationContactPayload';
  boolean: Maybe<Scalars['Boolean']['output']>;
  errors: Maybe<Array<DeleteOrganizationContactError>>;
};

export type DeleteOrganizationUnitError = EntityNotFoundError | EntityReferencedError;

export type DeleteOrganizationUnitInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteOrganizationUnitPayload = {
  __typename: 'DeleteOrganizationUnitPayload';
  boolean: Maybe<Scalars['Boolean']['output']>;
  errors: Maybe<Array<DeleteOrganizationUnitError>>;
};

export type DeletePaymentAccountError = EntityNotFoundError;

export type DeletePaymentAccountInput = {
  id: Scalars['UUID']['input'];
};

export type DeletePaymentAccountPayload = {
  __typename: 'DeletePaymentAccountPayload';
  boolean: Maybe<Scalars['Boolean']['output']>;
  errors: Maybe<Array<DeletePaymentAccountError>>;
};

export type DeletePaymentGatewayError = EntityNotFoundError | EntityReferencedError;

export type DeletePaymentGatewayInput = {
  id: Scalars['UUID']['input'];
};

export type DeletePaymentGatewayPayload = {
  __typename: 'DeletePaymentGatewayPayload';
  boolean: Maybe<Scalars['Boolean']['output']>;
  errors: Maybe<Array<DeletePaymentGatewayError>>;
};

export type DeletePaymentTermError = EntityNotFoundError | EntityReferencedError;

export type DeletePaymentTermInput = {
  id: Scalars['UUID']['input'];
};

export type DeletePaymentTermPayload = {
  __typename: 'DeletePaymentTermPayload';
  boolean: Maybe<Scalars['Boolean']['output']>;
  errors: Maybe<Array<DeletePaymentTermError>>;
};

export type DeleteResourceError = EntityNotFoundError;

export type DeleteResourceInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteResourcePayload = {
  __typename: 'DeleteResourcePayload';
  boolean: Maybe<Scalars['Boolean']['output']>;
  errors: Maybe<Array<DeleteResourceError>>;
};

export type DeleteTaxRuleError = EntityNotFoundError | EntityReferencedError;

export type DeleteTaxRuleInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteTaxRulePayload = {
  __typename: 'DeleteTaxRulePayload';
  boolean: Maybe<Scalars['Boolean']['output']>;
  errors: Maybe<Array<DeleteTaxRuleError>>;
};

export type DisablePaymentAccountError = EntityNotFoundError;

export type DisablePaymentAccountInput = {
  id: Scalars['UUID']['input'];
};

export type DisablePaymentAccountPayload = {
  __typename: 'DisablePaymentAccountPayload';
  errors: Maybe<Array<DisablePaymentAccountError>>;
  paymentAccount: Maybe<PaymentAccount>;
};

/** Thrown when an entity is not found by ID within the tenant scope. */
export type EntityNotFoundError = Error & {
  __typename: 'EntityNotFoundError';
  message: Scalars['String']['output'];
};

/** Thrown when attempting to hard-delete an entity that has FK references. */
export type EntityReferencedError = Error & {
  __typename: 'EntityReferencedError';
  message: Scalars['String']['output'];
};

export type Error = {
  message: Scalars['String']['output'];
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type InvalidOperationError = Error & {
  __typename: 'InvalidOperationError';
  message: Scalars['String']['output'];
};

/** Thrown when a state transition is not allowed for the current entity state. */
export type InvalidStateTransitionError = Error & {
  __typename: 'InvalidStateTransitionError';
  message: Scalars['String']['output'];
};

/** A reseller-issued invitation for a new customer tenant to register under that reseller. */
export type Invitation = {
  __typename: 'Invitation';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  message: Maybe<Scalars['String']['output']>;
  recipientEmail: Scalars['String']['output'];
  recipientName: Maybe<Scalars['String']['output']>;
  recipientTenant: Maybe<Tenant>;
  /** The new customer tenant, set once the invitation is accepted. */
  recipientTenantId: Maybe<Scalars['UUID']['output']>;
  respondedAt: Maybe<Scalars['DateTime']['output']>;
  state: InvitationState;
  tenant: Maybe<Tenant>;
  /** The issuing reseller tenant. */
  tenantId: Scalars['UUID']['output'];
  token: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** A reseller-issued invitation for a new customer tenant to register under that reseller. */
export type InvitationFilterInput = {
  and?: InputMaybe<Array<InvitationFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  expiresAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InvitationFilterInput>>;
  recipientEmail?: InputMaybe<StringOperationFilterInput>;
  recipientName?: InputMaybe<StringOperationFilterInput>;
  recipientTenant?: InputMaybe<TenantFilterInput>;
  /** The new customer tenant, set once the invitation is accepted. */
  recipientTenantId?: InputMaybe<UuidOperationFilterInput>;
  respondedAt?: InputMaybe<DateTimeOperationFilterInput>;
  state?: InputMaybe<InvitationStateOperationFilterInput>;
  tenant?: InputMaybe<TenantFilterInput>;
  /** The issuing reseller tenant. */
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  token?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A reseller-issued invitation for a new customer tenant to register under that reseller. */
export type InvitationSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  expiresAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  message?: InputMaybe<SortEnumType>;
  recipientEmail?: InputMaybe<SortEnumType>;
  recipientName?: InputMaybe<SortEnumType>;
  recipientTenant?: InputMaybe<TenantSortInput>;
  /** The new customer tenant, set once the invitation is accepted. */
  recipientTenantId?: InputMaybe<SortEnumType>;
  respondedAt?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  tenant?: InputMaybe<TenantSortInput>;
  /** The issuing reseller tenant. */
  tenantId?: InputMaybe<SortEnumType>;
  token?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** Lifecycle state of a reseller-issued customer invitation. */
export type InvitationState =
  /** Recipient registered using the invitation token; tenant created. */
  | 'ACCEPTED'
  /** Recipient finished the backoffice setup workflow. */
  | 'COMPLETED'
  /** Sending the invitation email failed. */
  | 'FAILED'
  /** Reseller revoked the invitation before it was accepted. */
  | 'REVOKED'
  /** Invitation email sent (or created), awaiting registration. */
  | 'SENT';

export type InvitationStateOperationFilterInput = {
  eq?: InputMaybe<InvitationState>;
  in?: InputMaybe<Array<InvitationState>>;
  neq?: InputMaybe<InvitationState>;
  nin?: InputMaybe<Array<InvitationState>>;
};

/** A connection to a list of items. */
export type InvitationsConnection = {
  __typename: 'InvitationsConnection';
  /** A list of edges. */
  edges: Maybe<Array<InvitationsEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<Invitation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InvitationsEdge = {
  __typename: 'InvitationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Invitation;
};

/** Represents a software licence for an organization unit. */
export type Licence = {
  __typename: 'Licence';
  /** Extra data. Stored as jsonb. */
  additionalPropertiesJson: Maybe<Scalars['String']['output']>;
  appName: Scalars['String']['output'];
  appReglevel: Scalars['Int']['output'];
  appType: AppType;
  appVersion: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  databaseId: Maybe<Scalars['UUID']['output']>;
  deviceBrand: Maybe<Scalars['String']['output']>;
  deviceDetails: Maybe<Scalars['String']['output']>;
  deviceInfo: Maybe<Scalars['String']['output']>;
  deviceModel: Maybe<Scalars['String']['output']>;
  deviceOS: Maybe<Scalars['String']['output']>;
  deviceUid: Maybe<Scalars['String']['output']>;
  expirationDate: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  organizationUnit: Maybe<OrganizationUnit>;
  organizationUnitId: Maybe<Scalars['UUID']['output']>;
  registrationDate: Maybe<Scalars['DateTime']['output']>;
  serial: Scalars['String']['output'];
  state: LicenceState;
  subscriptionItem: Maybe<SubscriptionItem>;
  subscriptionItemId: Maybe<Scalars['UUID']['output']>;
  tenant: Tenant;
  tenantId: Scalars['UUID']['output'];
  terminalId: Maybe<Scalars['Int']['output']>;
  type: LicenceType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Thrown when attempting to create a licence for a tenant/database that already has one. */
export type LicenceAlreadyExistsError = Error & {
  __typename: 'LicenceAlreadyExistsError';
  message: Scalars['String']['output'];
};

/** Represents a software licence for an organization unit. */
export type LicenceFilterInput = {
  /** Extra data. Stored as jsonb. */
  additionalPropertiesJson?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<LicenceFilterInput>>;
  appName?: InputMaybe<StringOperationFilterInput>;
  appReglevel?: InputMaybe<IntOperationFilterInput>;
  appType?: InputMaybe<AppTypeOperationFilterInput>;
  appVersion?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  databaseId?: InputMaybe<UuidOperationFilterInput>;
  deviceBrand?: InputMaybe<StringOperationFilterInput>;
  deviceDetails?: InputMaybe<StringOperationFilterInput>;
  deviceInfo?: InputMaybe<StringOperationFilterInput>;
  deviceModel?: InputMaybe<StringOperationFilterInput>;
  deviceOS?: InputMaybe<StringOperationFilterInput>;
  deviceUid?: InputMaybe<StringOperationFilterInput>;
  expirationDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<LicenceFilterInput>>;
  organizationUnit?: InputMaybe<OrganizationUnitFilterInput>;
  organizationUnitId?: InputMaybe<UuidOperationFilterInput>;
  registrationDate?: InputMaybe<DateTimeOperationFilterInput>;
  serial?: InputMaybe<StringOperationFilterInput>;
  state?: InputMaybe<LicenceStateOperationFilterInput>;
  subscriptionItem?: InputMaybe<SubscriptionItemFilterInput>;
  subscriptionItemId?: InputMaybe<UuidOperationFilterInput>;
  tenant?: InputMaybe<TenantFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  terminalId?: InputMaybe<IntOperationFilterInput>;
  type?: InputMaybe<LicenceTypeOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represents a software licence for an organization unit. */
export type LicenceSortInput = {
  /** Extra data. Stored as jsonb. */
  additionalPropertiesJson?: InputMaybe<SortEnumType>;
  appName?: InputMaybe<SortEnumType>;
  appReglevel?: InputMaybe<SortEnumType>;
  appType?: InputMaybe<SortEnumType>;
  appVersion?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  databaseId?: InputMaybe<SortEnumType>;
  deviceBrand?: InputMaybe<SortEnumType>;
  deviceDetails?: InputMaybe<SortEnumType>;
  deviceInfo?: InputMaybe<SortEnumType>;
  deviceModel?: InputMaybe<SortEnumType>;
  deviceOS?: InputMaybe<SortEnumType>;
  deviceUid?: InputMaybe<SortEnumType>;
  expirationDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  organizationUnit?: InputMaybe<OrganizationUnitSortInput>;
  organizationUnitId?: InputMaybe<SortEnumType>;
  registrationDate?: InputMaybe<SortEnumType>;
  serial?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  subscriptionItem?: InputMaybe<SubscriptionItemSortInput>;
  subscriptionItemId?: InputMaybe<SortEnumType>;
  tenant?: InputMaybe<TenantSortInput>;
  tenantId?: InputMaybe<SortEnumType>;
  terminalId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** Represents the state of a licence. */
export type LicenceState = 'ACTIVE' | 'EXPIRED' | 'REVOKED' | 'SUSPENDED';

export type LicenceStateOperationFilterInput = {
  eq?: InputMaybe<LicenceState>;
  in?: InputMaybe<Array<LicenceState>>;
  neq?: InputMaybe<LicenceState>;
  nin?: InputMaybe<Array<LicenceState>>;
};

/** Represents the type of a licence. */
export type LicenceType =
  /** Demo/evaluation licence. */
  | 'DEMO'
  /** Developer licence. */
  | 'DEVELOPER'
  /** Full/commercial licence. */
  | 'FULL'
  /** Reseller licence. */
  | 'RESELLER'
  /** Trial licence. */
  | 'TRIAL';

export type LicenceTypeOperationFilterInput = {
  eq?: InputMaybe<LicenceType>;
  in?: InputMaybe<Array<LicenceType>>;
  neq?: InputMaybe<LicenceType>;
  nin?: InputMaybe<Array<LicenceType>>;
};

/** A connection to a list of items. */
export type LicencesConnection = {
  __typename: 'LicencesConnection';
  /** A list of edges. */
  edges: Maybe<Array<LicencesEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<Licence>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LicencesEdge = {
  __typename: 'LicencesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Licence;
};

export type ListFilterInputTypeOfAccountingDocumentFilterInput = {
  all?: InputMaybe<AccountingDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AccountingDocumentFilterInput>;
  some?: InputMaybe<AccountingDocumentFilterInput>;
};

export type ListFilterInputTypeOfAccountingDocumentItemFilterInput = {
  all?: InputMaybe<AccountingDocumentItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AccountingDocumentItemFilterInput>;
  some?: InputMaybe<AccountingDocumentItemFilterInput>;
};

export type ListFilterInputTypeOfLicenceFilterInput = {
  all?: InputMaybe<LicenceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LicenceFilterInput>;
  some?: InputMaybe<LicenceFilterInput>;
};

export type ListFilterInputTypeOfOrganizationAddressFilterInput = {
  all?: InputMaybe<OrganizationAddressFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrganizationAddressFilterInput>;
  some?: InputMaybe<OrganizationAddressFilterInput>;
};

export type ListFilterInputTypeOfOrganizationContactFilterInput = {
  all?: InputMaybe<OrganizationContactFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrganizationContactFilterInput>;
  some?: InputMaybe<OrganizationContactFilterInput>;
};

export type ListFilterInputTypeOfOrganizationUnitFilterInput = {
  all?: InputMaybe<OrganizationUnitFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrganizationUnitFilterInput>;
  some?: InputMaybe<OrganizationUnitFilterInput>;
};

export type ListFilterInputTypeOfPaymentAccountFilterInput = {
  all?: InputMaybe<PaymentAccountFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PaymentAccountFilterInput>;
  some?: InputMaybe<PaymentAccountFilterInput>;
};

export type ListFilterInputTypeOfPaymentFilterInput = {
  all?: InputMaybe<PaymentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PaymentFilterInput>;
  some?: InputMaybe<PaymentFilterInput>;
};

export type ListFilterInputTypeOfPaymentHistoryFilterInput = {
  all?: InputMaybe<PaymentHistoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PaymentHistoryFilterInput>;
  some?: InputMaybe<PaymentHistoryFilterInput>;
};

export type ListFilterInputTypeOfSubscriptionFilterInput = {
  all?: InputMaybe<SubscriptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SubscriptionFilterInput>;
  some?: InputMaybe<SubscriptionFilterInput>;
};

export type ListFilterInputTypeOfSubscriptionItemFilterInput = {
  all?: InputMaybe<SubscriptionItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SubscriptionItemFilterInput>;
  some?: InputMaybe<SubscriptionItemFilterInput>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type ListUnsignedByteOperationFilterInput = {
  all?: InputMaybe<UnsignedByteOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UnsignedByteOperationFilterInput>;
  some?: InputMaybe<UnsignedByteOperationFilterInput>;
};

/** Promotional main coupon for the buy-licence wizard banner. */
export type MainCouponPromo = {
  __typename: 'MainCouponPromo';
  code: Scalars['String']['output'];
  discountPercent: Scalars['Decimal']['output'];
  id: Scalars['UUID']['output'];
};

/** Thrown when a PaymentAccount has no valid mandate and collection cannot proceed. */
export type MandateNotFoundError = Error & {
  __typename: 'MandateNotFoundError';
  message: Scalars['String']['output'];
};

export type MarkInvitationFailedError = EntityNotFoundError | InvalidStateTransitionError;

export type MarkInvitationFailedInput = {
  id: Scalars['UUID']['input'];
};

export type MarkInvitationFailedPayload = {
  __typename: 'MarkInvitationFailedPayload';
  errors: Maybe<Array<MarkInvitationFailedError>>;
  invitation: Maybe<Invitation>;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type Mutation = {
  __typename: 'Mutation';
  /** Applies a coupon to an existing subscription (replaces any prior coupon). Super Admin only. */
  applyCouponToSubscription: ApplyCouponToSubscriptionPayload;
  /**
   * Cancels a subscription (Active / Pending / Suspended). Sets CancellationDate,
   * ExpiryDate from activation + plan commit, and state Cancelled.
   * Licences stay valid until ExpiryDate; the expiration job then sets Expired and revokes.
   */
  cancelSubscription: CancelSubscriptionPayload;
  /**
   * Marks the caller's own accepted invitation as completed once the recipient finishes onboarding.
   * Returns null when the current tenant has no accepted invitation (e.g. it did not come from an invite).
   */
  completeInvitation: CompleteInvitationPayload;
  /** Fulfills the order: Drop-in via sessionResult, or reuse via paymentAccountId. */
  confirmOrder: ConfirmOrderPayload;
  createAppVersion: CreateAppVersionPayload;
  /** Creates a coupon. Pricing fields are immutable after create. */
  createCoupon: CreateCouponPayload;
  /** Creates a new invitation for a prospective customer, generating a unique token. */
  createInvitation: CreateInvitationPayload;
  /**
   * Creates an open order. With paymentAccountId, skips Drop-in and fulfills on confirm.
   * Otherwise creates an Adyen Drop-in session; billing rows are created on confirm or webhook.
   */
  createOrder: CreateOrderPayload;
  /** Creates a new organization for the current tenant. */
  createOrganization: CreateOrganizationPayload;
  /** Creates a new organization address. */
  createOrganizationAddress: CreateOrganizationAddressPayload;
  /** Creates a new organization contact. */
  createOrganizationContact: CreateOrganizationContactPayload;
  /** Creates a new organization unit. */
  createOrganizationUnit: CreateOrganizationUnitPayload;
  /** SuperAdmin: insert an unallocated tenant credit pool row or a document-linked payment. */
  createPayment: CreatePaymentPayload;
  /** Creates a new payment gateway. */
  createPaymentGateway: CreatePaymentGatewayPayload;
  /** Creates a new payment term. */
  createPaymentTerm: CreatePaymentTermPayload;
  /** Creates a new plan. */
  createPlan: CreatePlanPayload;
  /** Creates a new product. */
  createProduct: CreateProductPayload;
  createProvisionPayout: CreateProvisionPayoutPayload;
  createResource: CreateResourcePayload;
  /** Creates a new tax rule. */
  createTaxRule: CreateTaxRulePayload;
  createTrialLicence: CreateTrialLicencePayload;
  deleteAppVersion: DeleteAppVersionPayload;
  /** Hard-deletes a coupon. */
  deleteCoupon: DeleteCouponPayload;
  /** Clears the main promotional coupon app setting. */
  deleteMainCoupon: DeleteMainCouponPayload;
  /** Deletes an organization address (Super Admin only). */
  deleteOrganizationAddress: DeleteOrganizationAddressPayload;
  /** Deletes an organization contact (Super Admin only). */
  deleteOrganizationContact: DeleteOrganizationContactPayload;
  /** Deletes an organization unit. */
  deleteOrganizationUnit: DeleteOrganizationUnitPayload;
  /** Deletes a payment account (Super Admin only). */
  deletePaymentAccount: DeletePaymentAccountPayload;
  /** Deletes a payment gateway. */
  deletePaymentGateway: DeletePaymentGatewayPayload;
  /** Deletes a payment term. */
  deletePaymentTerm: DeletePaymentTermPayload;
  deleteResource: DeleteResourcePayload;
  /** Deletes a tax rule. */
  deleteTaxRule: DeleteTaxRulePayload;
  /** Soft-disables a payment account. Mandate data is preserved; provider collection is blocked via IsActive. */
  disablePaymentAccount: DisablePaymentAccountPayload;
  /** Marks an invitation as failed after the invitation email could not be sent. */
  markInvitationFailed: MarkInvitationFailedPayload;
  payQuote: PayQuotePayload;
  /**
   * Refunds a completed payment via the external provider.
   * Only payments in the Completed state with a provider payment ID can be refunded.
   */
  refundPayment: RefundPaymentPayload;
  /** Removes the applied coupon from a subscription. Super Admin only. */
  removeCouponFromSubscription: RemoveCouponFromSubscriptionPayload;
  reorderResources: ReorderResourcesPayload;
  replayAllFailedWebhooks: ReplayAllFailedWebhooksPayload;
  replayFailedWebhook: ReplayFailedWebhookPayload;
  /** Retries a previously failed (or re-sends a pending) invitation, reusing the same token. */
  resendInvitation: ResendInvitationPayload;
  /** SuperAdmin: reload buyer from master data, rebuild PDF/XML, and email the customer again. */
  resendInvoiceWithRefreshedAddress: ResendInvoiceWithRefreshedAddressPayload;
  /** Re-opens an unfinished Drop-in order with a fresh Adyen session for the same order id. */
  resumeOrder: ResumeOrderPayload;
  /**
   * Manually retries a failed payment.
   * Uses a fresh idempotency key per retry attempt ({payment.Id}-{retryAttempt} when
   * retryAttempt > 0) so the provider treats each retry as a new submission.
   * Within a single attempt the key is stable, so a response-lost replay still deduplicates.
   * Only payments in the Failed state can be retried.
   */
  retryPayment: RetryPaymentPayload;
  /** Revokes an invitation that has not yet been accepted, so its token can no longer be used. */
  revokeInvitation: RevokeInvitationPayload;
  /** Suspends a subscription. Only Active or Pending subscriptions can be suspended. */
  suspendSubscription: SuspendSubscriptionPayload;
  updateAppVersion: UpdateAppVersionPayload;
  /**
   * Updates global version policy in app_settings. Null values remove that setting.
   * Non-null version strings must match an active AppVersion row.
   */
  updateAppVersionPolicy: UpdateAppVersionPolicyPayload;
  /** Updates coupon metadata and scoping. Pricing fields cannot be changed. */
  updateCoupon: UpdateCouponPayload;
  /**
   * Sets the licence state (Active, Expired, Suspended, Revoked).
   * Super Admin: any licence. Reseller: licence for a tenant with matching ResellerId. Otherwise: own tenant only.
   */
  updateLicenceState: UpdateLicenceStatePayload;
  updateMainCoupon: UpdateMainCouponPayload;
  /** Updates an open order's price snapshot and issues a fresh Adyen session for the same order id. */
  updateOrder: UpdateOrderPayload;
  /** Updates an existing organization. */
  updateOrganization: UpdateOrganizationPayload;
  /** Updates an existing organization address. */
  updateOrganizationAddress: UpdateOrganizationAddressPayload;
  /** Updates an existing organization contact. */
  updateOrganizationContact: UpdateOrganizationContactPayload;
  /** Updates an existing organization unit. */
  updateOrganizationUnit: UpdateOrganizationUnitPayload;
  /** Updates an existing payment account. */
  updatePaymentAccount: UpdatePaymentAccountPayload;
  /** Updates an existing payment gateway. */
  updatePaymentGateway: UpdatePaymentGatewayPayload;
  /** Updates an existing payment term. */
  updatePaymentTerm: UpdatePaymentTermPayload;
  /** Updates an existing plan. */
  updatePlan: UpdatePlanPayload;
  /** Updates an existing product. */
  updateProduct: UpdateProductPayload;
  updateResource: UpdateResourcePayload;
  /**
   * Re-points a subscription at a different PaymentAccount (the customer's only legitimate
   * edit target on a sub). All money + cadence are derived from the Plan and intentionally
   * not editable here — re-issuing under a new Plan is a separate flow.
   */
  updateSubscriptionPaymentAccount: UpdateSubscriptionPaymentAccountPayload;
  /** Updates an existing tax rule. */
  updateTaxRule: UpdateTaxRulePayload;
  updateTenantDiscountPercent: UpdateTenantDiscountPercentPayload;
  updateTenantResellerLogo: UpdateTenantResellerLogoPayload;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationApplyCouponToSubscriptionArgs = {
  input: ApplyCouponToSubscriptionInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationConfirmOrderArgs = {
  input: ConfirmOrderInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationCreateAppVersionArgs = {
  input: CreateAppVersionInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationCreateCouponArgs = {
  input: CreateCouponInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationCreateInvitationArgs = {
  input: CreateInvitationInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationCreateOrganizationAddressArgs = {
  input: CreateOrganizationAddressInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationCreateOrganizationContactArgs = {
  input: CreateOrganizationContactInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationCreateOrganizationUnitArgs = {
  input: CreateOrganizationUnitInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationCreatePaymentGatewayArgs = {
  input: CreatePaymentGatewayInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationCreatePaymentTermArgs = {
  input: CreatePaymentTermInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationCreatePlanArgs = {
  input: CreatePlanInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationCreateProductArgs = {
  input: CreateProductInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationCreateProvisionPayoutArgs = {
  input: CreateProvisionPayoutInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationCreateResourceArgs = {
  input: CreateResourceInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationCreateTaxRuleArgs = {
  input: CreateTaxRuleInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationCreateTrialLicenceArgs = {
  input: CreateTrialLicenceInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationDeleteAppVersionArgs = {
  input: DeleteAppVersionInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationDeleteCouponArgs = {
  input: DeleteCouponInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationDeleteOrganizationAddressArgs = {
  input: DeleteOrganizationAddressInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationDeleteOrganizationContactArgs = {
  input: DeleteOrganizationContactInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationDeleteOrganizationUnitArgs = {
  input: DeleteOrganizationUnitInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationDeletePaymentAccountArgs = {
  input: DeletePaymentAccountInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationDeletePaymentGatewayArgs = {
  input: DeletePaymentGatewayInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationDeletePaymentTermArgs = {
  input: DeletePaymentTermInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationDeleteResourceArgs = {
  input: DeleteResourceInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationDeleteTaxRuleArgs = {
  input: DeleteTaxRuleInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationDisablePaymentAccountArgs = {
  input: DisablePaymentAccountInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationMarkInvitationFailedArgs = {
  input: MarkInvitationFailedInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationPayQuoteArgs = {
  input: PayQuoteInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationRefundPaymentArgs = {
  input: RefundPaymentInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationRemoveCouponFromSubscriptionArgs = {
  input: RemoveCouponFromSubscriptionInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationReorderResourcesArgs = {
  input: ReorderResourcesInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationReplayAllFailedWebhooksArgs = {
  input: ReplayAllFailedWebhooksInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationReplayFailedWebhookArgs = {
  input: ReplayFailedWebhookInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationResendInvitationArgs = {
  input: ResendInvitationInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationResendInvoiceWithRefreshedAddressArgs = {
  input: ResendInvoiceWithRefreshedAddressInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationResumeOrderArgs = {
  input: ResumeOrderInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationRetryPaymentArgs = {
  input: RetryPaymentInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationRevokeInvitationArgs = {
  input: RevokeInvitationInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationSuspendSubscriptionArgs = {
  input: SuspendSubscriptionInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdateAppVersionArgs = {
  input: UpdateAppVersionInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdateAppVersionPolicyArgs = {
  input: UpdateAppVersionPolicyInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdateCouponArgs = {
  input: UpdateCouponInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdateLicenceStateArgs = {
  input: UpdateLicenceStateInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdateMainCouponArgs = {
  input: UpdateMainCouponInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdateOrganizationAddressArgs = {
  input: UpdateOrganizationAddressInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdateOrganizationContactArgs = {
  input: UpdateOrganizationContactInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdateOrganizationUnitArgs = {
  input: UpdateOrganizationUnitInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdatePaymentAccountArgs = {
  input: UpdatePaymentAccountInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdatePaymentGatewayArgs = {
  input: UpdatePaymentGatewayInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdatePaymentTermArgs = {
  input: UpdatePaymentTermInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdatePlanArgs = {
  input: UpdatePlanInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdateResourceArgs = {
  input: UpdateResourceInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdateSubscriptionPaymentAccountArgs = {
  input: UpdateSubscriptionPaymentAccountInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdateTaxRuleArgs = {
  input: UpdateTaxRuleInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdateTenantDiscountPercentArgs = {
  input: UpdateTenantDiscountPercentInput;
};

/** GraphQL mutations for organizations (status transitions, no hard delete). */
export type MutationUpdateTenantResellerLogoArgs = {
  input: UpdateTenantResellerLogoInput;
};

export type NullableOfPaymentStateOperationFilterInput = {
  eq?: InputMaybe<PaymentState>;
  in?: InputMaybe<Array<InputMaybe<PaymentState>>>;
  neq?: InputMaybe<PaymentState>;
  nin?: InputMaybe<Array<InputMaybe<PaymentState>>>;
};

/**
 * Pre-payment intent for Adyen Drop-in checkout: holds picks and price snapshot until confirmed.
 * Id is sent to Adyen as session reference / webhook merchantReference.
 * Billing rows are materialized by IOrderService on confirm or webhook.
 */
export type Order = {
  __typename: 'Order';
  amountGross: Scalars['Decimal']['output'];
  amountNet: Scalars['Decimal']['output'];
  couponCode: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currencyCode: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** [{ "sku": "...", "quantity": 1 }] */
  itemsJson: Scalars['String']['output'];
  organizationUnit: OrganizationUnit;
  organizationUnitId: Scalars['UUID']['output'];
  paymentGateway: PaymentGateway;
  paymentGatewayId: Scalars['UUID']['output'];
  plan: Maybe<Plan>;
  planId: Maybe<Scalars['UUID']['output']>;
  /** Adyen session id returned from /sessions; used for server-side session verification. */
  sessionId: Maybe<Scalars['String']['output']>;
  state: OrderState;
  subscription: Maybe<Subscription>;
  /** Subscription created when this order is fulfilled. */
  subscriptionId: Maybe<Scalars['UUID']['output']>;
  taxRuleId: Maybe<Scalars['UUID']['output']>;
  tenant: Tenant;
  tenantId: Scalars['UUID']['output'];
  type: OrderType;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type OrderState =
  | 'EXPIRED'
  | 'FAILED'
  | 'OPEN'
  | 'PAID'
  /** Claimed by a confirm attempt; guards against concurrent double-fulfillment. */
  | 'PROCESSING';

export type OrderType = 'ONE_TIME' | 'SUBSCRIPTION';

/** Represents an organization within a tenant. */
export type Organization = {
  __typename: 'Organization';
  addresses: Array<OrganizationAddress>;
  contacts: Array<OrganizationContact>;
  createdAt: Scalars['DateTime']['output'];
  customerNumber: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  status: OrganizationStatus;
  tenant: Tenant;
  tenantId: Scalars['UUID']['output'];
  type: Maybe<Scalars['String']['output']>;
  units: Array<OrganizationUnit>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents an address for an organization. */
export type OrganizationAddress = {
  __typename: 'OrganizationAddress';
  addressLine1: Maybe<Scalars['String']['output']>;
  addressLine2: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isDefault: Scalars['Boolean']['output'];
  latitude: Maybe<Scalars['Decimal']['output']>;
  longitude: Maybe<Scalars['Decimal']['output']>;
  organization: Organization;
  organizationId: Scalars['UUID']['output'];
  organizationUnit: Maybe<OrganizationUnit>;
  organizationUnitId: Maybe<Scalars['UUID']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantId: Scalars['UUID']['output'];
  type: AddressType;
  updatedAt: Scalars['DateTime']['output'];
  zipCode: Maybe<Scalars['String']['output']>;
};

/** Represents an address for an organization. */
export type OrganizationAddressFilterInput = {
  addressLine1?: InputMaybe<StringOperationFilterInput>;
  addressLine2?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<OrganizationAddressFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  latitude?: InputMaybe<DecimalOperationFilterInput>;
  longitude?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<OrganizationAddressFilterInput>>;
  organization?: InputMaybe<OrganizationFilterInput>;
  organizationId?: InputMaybe<UuidOperationFilterInput>;
  organizationUnit?: InputMaybe<OrganizationUnitFilterInput>;
  organizationUnitId?: InputMaybe<UuidOperationFilterInput>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  tenant?: InputMaybe<TenantFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  type?: InputMaybe<AddressTypeOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  zipCode?: InputMaybe<StringOperationFilterInput>;
};

/** Represents an address for an organization. */
export type OrganizationAddressSortInput = {
  addressLine1?: InputMaybe<SortEnumType>;
  addressLine2?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  latitude?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
  organization?: InputMaybe<OrganizationSortInput>;
  organizationId?: InputMaybe<SortEnumType>;
  organizationUnit?: InputMaybe<OrganizationUnitSortInput>;
  organizationUnitId?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenant?: InputMaybe<TenantSortInput>;
  tenantId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  zipCode?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type OrganizationAddressesConnection = {
  __typename: 'OrganizationAddressesConnection';
  /** A list of edges. */
  edges: Maybe<Array<OrganizationAddressesEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<OrganizationAddress>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationAddressesEdge = {
  __typename: 'OrganizationAddressesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrganizationAddress;
};

/** Represents a contact person for an organization. */
export type OrganizationContact = {
  __typename: 'OrganizationContact';
  createdAt: Scalars['DateTime']['output'];
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationId: Scalars['UUID']['output'];
  position: Maybe<Scalars['String']['output']>;
  salutation: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents a contact person for an organization. */
export type OrganizationContactFilterInput = {
  and?: InputMaybe<Array<OrganizationContactFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrganizationContactFilterInput>>;
  organization?: InputMaybe<OrganizationFilterInput>;
  organizationId?: InputMaybe<UuidOperationFilterInput>;
  position?: InputMaybe<StringOperationFilterInput>;
  salutation?: InputMaybe<StringOperationFilterInput>;
  tenant?: InputMaybe<TenantFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represents a contact person for an organization. */
export type OrganizationContactSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  organization?: InputMaybe<OrganizationSortInput>;
  organizationId?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
  salutation?: InputMaybe<SortEnumType>;
  tenant?: InputMaybe<TenantSortInput>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type OrganizationContactsConnection = {
  __typename: 'OrganizationContactsConnection';
  /** A list of edges. */
  edges: Maybe<Array<OrganizationContactsEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<OrganizationContact>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationContactsEdge = {
  __typename: 'OrganizationContactsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrganizationContact;
};

/** Represents an organization within a tenant. */
export type OrganizationFilterInput = {
  addresses?: InputMaybe<ListFilterInputTypeOfOrganizationAddressFilterInput>;
  and?: InputMaybe<Array<OrganizationFilterInput>>;
  contacts?: InputMaybe<ListFilterInputTypeOfOrganizationContactFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerNumber?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrganizationFilterInput>>;
  status?: InputMaybe<OrganizationStatusOperationFilterInput>;
  tenant?: InputMaybe<TenantFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  units?: InputMaybe<ListFilterInputTypeOfOrganizationUnitFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represents an organization within a tenant. */
export type OrganizationSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  customerNumber?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenant?: InputMaybe<TenantSortInput>;
  tenantId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** Represents the status of an organization. */
export type OrganizationStatus = 'ACTIVE' | 'INACTIVE' | 'SUSPENDED';

export type OrganizationStatusOperationFilterInput = {
  eq?: InputMaybe<OrganizationStatus>;
  in?: InputMaybe<Array<OrganizationStatus>>;
  neq?: InputMaybe<OrganizationStatus>;
  nin?: InputMaybe<Array<OrganizationStatus>>;
};

/** Represents an organizational unit or branch. */
export type OrganizationUnit = {
  __typename: 'OrganizationUnit';
  /** Extra data. Stored as jsonb. */
  additionalPropertiesJson: Maybe<Scalars['String']['output']>;
  addresses: Array<OrganizationAddress>;
  appType: Maybe<Scalars['String']['output']>;
  branchType: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  databaseId: Maybe<Scalars['UUID']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  licences: Array<Licence>;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['UUID']['output'];
  paymentAccounts: Array<PaymentAccount>;
  sort: Scalars['Int']['output'];
  subscriptions: Array<Subscription>;
  tenant: Tenant;
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents an organizational unit or branch. */
export type OrganizationUnitFilterInput = {
  /** Extra data. Stored as jsonb. */
  additionalPropertiesJson?: InputMaybe<StringOperationFilterInput>;
  addresses?: InputMaybe<ListFilterInputTypeOfOrganizationAddressFilterInput>;
  and?: InputMaybe<Array<OrganizationUnitFilterInput>>;
  appType?: InputMaybe<StringOperationFilterInput>;
  branchType?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  databaseId?: InputMaybe<UuidOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  licences?: InputMaybe<ListFilterInputTypeOfLicenceFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrganizationUnitFilterInput>>;
  organization?: InputMaybe<OrganizationFilterInput>;
  organizationId?: InputMaybe<UuidOperationFilterInput>;
  paymentAccounts?: InputMaybe<ListFilterInputTypeOfPaymentAccountFilterInput>;
  sort?: InputMaybe<IntOperationFilterInput>;
  subscriptions?: InputMaybe<ListFilterInputTypeOfSubscriptionFilterInput>;
  tenant?: InputMaybe<TenantFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represents an organizational unit or branch. */
export type OrganizationUnitSortInput = {
  /** Extra data. Stored as jsonb. */
  additionalPropertiesJson?: InputMaybe<SortEnumType>;
  appType?: InputMaybe<SortEnumType>;
  branchType?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  databaseId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  organization?: InputMaybe<OrganizationSortInput>;
  organizationId?: InputMaybe<SortEnumType>;
  sort?: InputMaybe<SortEnumType>;
  tenant?: InputMaybe<TenantSortInput>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type OrganizationUnitsConnection = {
  __typename: 'OrganizationUnitsConnection';
  /** A list of edges. */
  edges: Maybe<Array<OrganizationUnitsEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<OrganizationUnit>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationUnitsEdge = {
  __typename: 'OrganizationUnitsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrganizationUnit;
};

/** A connection to a list of items. */
export type OrganizationsConnection = {
  __typename: 'OrganizationsConnection';
  /** A list of edges. */
  edges: Maybe<Array<OrganizationsEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<Organization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationsEdge = {
  __typename: 'OrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Organization;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export type PayQuoteError =
  | EntityNotFoundError
  | InvalidOperationError
  | InvalidStateTransitionError;

export type PayQuoteInput = {
  organizationUnitId: Scalars['UUID']['input'];
  paymentAccountId: Scalars['UUID']['input'];
  quoteId: Scalars['UUID']['input'];
};

export type PayQuotePayload = {
  __typename: 'PayQuotePayload';
  errors: Maybe<Array<PayQuoteError>>;
  paymentAccount: Maybe<PaymentAccount>;
};

/** Represents a payment for an accounting document, or an unallocated customer credit (no document). */
export type Payment = {
  __typename: 'Payment';
  accountingDocument: Maybe<AccountingDocument>;
  /** Null for unallocated customer-credit pool rows (tenant-scoped, no invoice). */
  accountingDocumentId: Maybe<Scalars['UUID']['output']>;
  /** Provider-specific data (e.g. Adyen PSP reference). Stored as jsonb. */
  additionalPropertiesJson: Maybe<Scalars['String']['output']>;
  amountGross: Scalars['Decimal']['output'];
  amountNet: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  currencyCode: Maybe<Scalars['String']['output']>;
  direction: PaymentDirection;
  id: Scalars['UUID']['output'];
  organizationUnit: Maybe<OrganizationUnit>;
  organizationUnitId: Maybe<Scalars['UUID']['output']>;
  paymentDate: Maybe<Scalars['DateTime']['output']>;
  paymentGateway: Maybe<PaymentGateway>;
  paymentGatewayId: Maybe<Scalars['UUID']['output']>;
  /**
   * Append-only lifecycle log. Hidden from the default GraphQL schema shape by
   * PaymentType; exposed only via PaymentType.History (SuperAdmin-gated).
   */
  paymentHistories: Array<PaymentHistory>;
  /**
   * External provider payment id (e.g. Adyen PSP reference). Stored inside
   * AdditionalPropertiesJson; first writer wins (set-if-absent) so a later
   * webhook never overwrites the original charge reference.
   */
  providerPaymentId: Maybe<Scalars['String']['output']>;
  /** External reference (e.g. invoice number for provider payments). */
  reference: Maybe<Scalars['String']['output']>;
  state: PaymentState;
  tenant: Maybe<Tenant>;
  tenantId: Maybe<Scalars['UUID']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Represents a payment account configuration. */
export type PaymentAccount = {
  __typename: 'PaymentAccount';
  /** Raw JSON blob for provider-specific data. Stored as jsonb for efficient JSON operator queries. */
  additionalPropertiesJson: Maybe<Scalars['String']['output']>;
  /** True when active and a stored method exists (Adyen token or SEPA mandate). */
  canCollect: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** When false, the account is soft-disabled and must not be used for provider collection. */
  isActive: Scalars['Boolean']['output'];
  organizationUnits: Array<OrganizationUnit>;
  paymentGateway: Maybe<PaymentGateway>;
  paymentGatewayId: Maybe<Scalars['UUID']['output']>;
  /**
   * Stored payment method (token / mandate / bank summary). Persisted inside
   * AdditionalPropertiesJson under the paymentMethod key; not a DB column.
   */
  paymentMethod: Maybe<PaymentMethodInfo>;
  paymentTerm: Maybe<PaymentTerm>;
  paymentTermId: Maybe<Scalars['UUID']['output']>;
  subscriptions: Array<Subscription>;
  taxRule: Maybe<TaxRule>;
  taxRuleId: Maybe<Scalars['UUID']['output']>;
  tenant: Tenant;
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents a payment account configuration. */
export type PaymentAccountFilterInput = {
  /** Raw JSON blob for provider-specific data. Stored as jsonb for efficient JSON operator queries. */
  additionalPropertiesJson?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<PaymentAccountFilterInput>>;
  /** True when active and a stored method exists (Adyen token or SEPA mandate). */
  canCollect?: InputMaybe<BooleanOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  /** When false, the account is soft-disabled and must not be used for provider collection. */
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<PaymentAccountFilterInput>>;
  organizationUnits?: InputMaybe<ListFilterInputTypeOfOrganizationUnitFilterInput>;
  paymentGateway?: InputMaybe<PaymentGatewayFilterInput>;
  paymentGatewayId?: InputMaybe<UuidOperationFilterInput>;
  /**
   * Stored payment method (token / mandate / bank summary). Persisted inside
   * AdditionalPropertiesJson under the paymentMethod key; not a DB column.
   */
  paymentMethod?: InputMaybe<PaymentMethodInfoFilterInput>;
  paymentTerm?: InputMaybe<PaymentTermFilterInput>;
  paymentTermId?: InputMaybe<UuidOperationFilterInput>;
  subscriptions?: InputMaybe<ListFilterInputTypeOfSubscriptionFilterInput>;
  taxRule?: InputMaybe<TaxRuleFilterInput>;
  taxRuleId?: InputMaybe<UuidOperationFilterInput>;
  tenant?: InputMaybe<TenantFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represents a payment account configuration. */
export type PaymentAccountSortInput = {
  /** Raw JSON blob for provider-specific data. Stored as jsonb for efficient JSON operator queries. */
  additionalPropertiesJson?: InputMaybe<SortEnumType>;
  /** True when active and a stored method exists (Adyen token or SEPA mandate). */
  canCollect?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** When false, the account is soft-disabled and must not be used for provider collection. */
  isActive?: InputMaybe<SortEnumType>;
  paymentGateway?: InputMaybe<PaymentGatewaySortInput>;
  paymentGatewayId?: InputMaybe<SortEnumType>;
  /**
   * Stored payment method (token / mandate / bank summary). Persisted inside
   * AdditionalPropertiesJson under the paymentMethod key; not a DB column.
   */
  paymentMethod?: InputMaybe<PaymentMethodInfoSortInput>;
  paymentTerm?: InputMaybe<PaymentTermSortInput>;
  paymentTermId?: InputMaybe<SortEnumType>;
  taxRule?: InputMaybe<TaxRuleSortInput>;
  taxRuleId?: InputMaybe<SortEnumType>;
  tenant?: InputMaybe<TenantSortInput>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type PaymentAccountsConnection = {
  __typename: 'PaymentAccountsConnection';
  /** A list of edges. */
  edges: Maybe<Array<PaymentAccountsEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<PaymentAccount>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PaymentAccountsEdge = {
  __typename: 'PaymentAccountsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PaymentAccount;
};

/** Represents the direction of a payment. */
export type PaymentDirection = 'IN' | 'OUT';

export type PaymentDirectionOperationFilterInput = {
  eq?: InputMaybe<PaymentDirection>;
  in?: InputMaybe<Array<PaymentDirection>>;
  neq?: InputMaybe<PaymentDirection>;
  nin?: InputMaybe<Array<PaymentDirection>>;
};

/**
 * Canonical payment lifecycle event written to the append-only payment_history log.
 * Names chosen to map 1:1 to common provider events (Stripe, Adyen) and to the
 * internal PaymentState transitions.
 */
export type PaymentEventType =
  /**
   * Transition from Completed to Failed
   * via dispute / reversal (GC: charged_back, Stripe: dispute).
   */
  | 'CHARGED_BACK'
  /** Transition to Completed (GC: paid_out, Stripe: succeeded). */
  | 'COMPLETED'
  /** Payment row inserted (state = Pending). */
  | 'CREATED'
  /** Provider event arrived but the state-machine rejected the transition. Audit only. */
  | 'EVENT_SKIPPED'
  /** Transition to Failed from a first-attempt rejection. */
  | 'FAILED'
  /** Transition to Refunded. */
  | 'REFUNDED'
  /**
   * Refund reversed by provider (GC: refund_bounced / refund_funds_returned, Stripe: refund.failed);
   * payment moves RefundPending → Completed.
   */
  | 'REFUND_FAILED'
  /** Transition to RefundPending. */
  | 'REFUND_SUBMITTED'
  /**
   * Provider charge or manual retry dispatched. Reason disambiguates: "initial",
   * "retry_manual", "credit_covered".
   */
  | 'SUBMITTED';

export type PaymentEventTypeOperationFilterInput = {
  eq?: InputMaybe<PaymentEventType>;
  in?: InputMaybe<Array<PaymentEventType>>;
  neq?: InputMaybe<PaymentEventType>;
  nin?: InputMaybe<Array<PaymentEventType>>;
};

/** Represents a payment for an accounting document, or an unallocated customer credit (no document). */
export type PaymentFilterInput = {
  accountingDocument?: InputMaybe<AccountingDocumentFilterInput>;
  /** Null for unallocated customer-credit pool rows (tenant-scoped, no invoice). */
  accountingDocumentId?: InputMaybe<UuidOperationFilterInput>;
  /** Provider-specific data (e.g. Adyen PSP reference). Stored as jsonb. */
  additionalPropertiesJson?: InputMaybe<StringOperationFilterInput>;
  amountGross?: InputMaybe<DecimalOperationFilterInput>;
  amountNet?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<PaymentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  currencyCode?: InputMaybe<StringOperationFilterInput>;
  direction?: InputMaybe<PaymentDirectionOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<PaymentFilterInput>>;
  organizationUnit?: InputMaybe<OrganizationUnitFilterInput>;
  organizationUnitId?: InputMaybe<UuidOperationFilterInput>;
  paymentDate?: InputMaybe<DateTimeOperationFilterInput>;
  paymentGateway?: InputMaybe<PaymentGatewayFilterInput>;
  paymentGatewayId?: InputMaybe<UuidOperationFilterInput>;
  /**
   * Append-only lifecycle log. Hidden from the default GraphQL schema shape by
   * PaymentType; exposed only via PaymentType.History (SuperAdmin-gated).
   */
  paymentHistories?: InputMaybe<ListFilterInputTypeOfPaymentHistoryFilterInput>;
  /**
   * External provider payment id (e.g. Adyen PSP reference). Stored inside
   * AdditionalPropertiesJson; first writer wins (set-if-absent) so a later
   * webhook never overwrites the original charge reference.
   */
  providerPaymentId?: InputMaybe<StringOperationFilterInput>;
  /** External reference (e.g. invoice number for provider payments). */
  reference?: InputMaybe<StringOperationFilterInput>;
  state?: InputMaybe<PaymentStateOperationFilterInput>;
  tenant?: InputMaybe<TenantFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represents a payment gateway provider. */
export type PaymentGateway = {
  __typename: 'PaymentGateway';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  paymentAccounts: Array<PaymentAccount>;
  payments: Array<Payment>;
  provider: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents a payment gateway provider. */
export type PaymentGatewayFilterInput = {
  and?: InputMaybe<Array<PaymentGatewayFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PaymentGatewayFilterInput>>;
  paymentAccounts?: InputMaybe<ListFilterInputTypeOfPaymentAccountFilterInput>;
  payments?: InputMaybe<ListFilterInputTypeOfPaymentFilterInput>;
  provider?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represents a payment gateway provider. */
export type PaymentGatewaySortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  provider?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type PaymentGatewaysConnection = {
  __typename: 'PaymentGatewaysConnection';
  /** A list of edges. */
  edges: Maybe<Array<PaymentGatewaysEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<PaymentGateway>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PaymentGatewaysEdge = {
  __typename: 'PaymentGatewaysEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PaymentGateway;
};

/**
 * Append-only audit row for a Payment lifecycle event. One row per
 * transition or key action; never updated after insert. Deduplication is handled upstream
 * by WebhookQueue (unique Provider, ProviderEventId) and the payment
 * state machine, so no unique index lives here.
 */
export type PaymentHistory = {
  __typename: 'PaymentHistory';
  /** Provider references, amounts, or attempt numbers that do not warrant dedicated columns. */
  additionalPropertiesJson: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Free-text error detail attached to Failed rows. */
  errorMessage: Maybe<Scalars['String']['output']>;
  eventType: PaymentEventType;
  /** Payment state before the transition. Null for non-transition rows (e.g. Submitted). */
  fromState: Maybe<PaymentState>;
  id: Scalars['UUID']['output'];
  payment: Payment;
  paymentId: Scalars['UUID']['output'];
  /** Correlates this row with the provider webhook event (e.g. Adyen PSP reference). Null for internal events. */
  providerEventId: Maybe<Scalars['String']['output']>;
  /** Short machine-readable tag ("initial", "retry_manual", "credit_covered", "invalid_transition"...). */
  reason: Maybe<Scalars['String']['output']>;
  /** Payment state after the transition. Null for audit-only rows (e.g. EventSkipped). */
  toState: Maybe<PaymentState>;
  /** Included for entity-shape consistency; never written after insert (rows are append-only). */
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Append-only audit row for a Payment lifecycle event. One row per
 * transition or key action; never updated after insert. Deduplication is handled upstream
 * by WebhookQueue (unique Provider, ProviderEventId) and the payment
 * state machine, so no unique index lives here.
 */
export type PaymentHistoryFilterInput = {
  /** Provider references, amounts, or attempt numbers that do not warrant dedicated columns. */
  additionalPropertiesJson?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<PaymentHistoryFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Free-text error detail attached to Failed rows. */
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  eventType?: InputMaybe<PaymentEventTypeOperationFilterInput>;
  /** Payment state before the transition. Null for non-transition rows (e.g. Submitted). */
  fromState?: InputMaybe<NullableOfPaymentStateOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<PaymentHistoryFilterInput>>;
  payment?: InputMaybe<PaymentFilterInput>;
  paymentId?: InputMaybe<UuidOperationFilterInput>;
  /** Correlates this row with the provider webhook event (e.g. Adyen PSP reference). Null for internal events. */
  providerEventId?: InputMaybe<StringOperationFilterInput>;
  /** Short machine-readable tag ("initial", "retry_manual", "credit_covered", "invalid_transition"...). */
  reason?: InputMaybe<StringOperationFilterInput>;
  /** Payment state after the transition. Null for audit-only rows (e.g. EventSkipped). */
  toState?: InputMaybe<NullableOfPaymentStateOperationFilterInput>;
  /** Included for entity-shape consistency; never written after insert (rows are append-only). */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * Provider-agnostic stored payment method. One nested object on
 * AdditionalPropertiesJson under the paymentMethod key —
 * Adyen fills Token/Kind/Ending
 * (plus MandateId for SEPA direct debit).
 */
export type PaymentMethodInfo = {
  __typename: 'PaymentMethodInfo';
  /** Bank name (SEPA direct debit). */
  bankName: Maybe<Scalars['String']['output']>;
  /** Last few digits of the bank account / card. */
  ending: Maybe<Scalars['String']['output']>;
  /** Shopper-facing category (e.g. visa, sepadirectdebit). */
  kind: Maybe<Scalars['String']['output']>;
  /** SEPA mandate id (e.g. from Adyen sepadirectdebit.mandateId). */
  mandateId: Maybe<Scalars['String']['output']>;
  /** Adyen stored payment method token (recurring reference). */
  token: Maybe<Scalars['String']['output']>;
};

/**
 * Provider-agnostic stored payment method. One nested object on
 * AdditionalPropertiesJson under the paymentMethod key —
 * Adyen fills Token/Kind/Ending
 * (plus MandateId for SEPA direct debit).
 */
export type PaymentMethodInfoFilterInput = {
  and?: InputMaybe<Array<PaymentMethodInfoFilterInput>>;
  /** Bank name (SEPA direct debit). */
  bankName?: InputMaybe<StringOperationFilterInput>;
  /** Last few digits of the bank account / card. */
  ending?: InputMaybe<StringOperationFilterInput>;
  /** Shopper-facing category (e.g. visa, sepadirectdebit). */
  kind?: InputMaybe<StringOperationFilterInput>;
  /** SEPA mandate id (e.g. from Adyen sepadirectdebit.mandateId). */
  mandateId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PaymentMethodInfoFilterInput>>;
  /** Adyen stored payment method token (recurring reference). */
  token?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Provider-agnostic stored payment method. One nested object on
 * AdditionalPropertiesJson under the paymentMethod key —
 * Adyen fills Token/Kind/Ending
 * (plus MandateId for SEPA direct debit).
 */
export type PaymentMethodInfoSortInput = {
  /** Bank name (SEPA direct debit). */
  bankName?: InputMaybe<SortEnumType>;
  /** Last few digits of the bank account / card. */
  ending?: InputMaybe<SortEnumType>;
  /** Shopper-facing category (e.g. visa, sepadirectdebit). */
  kind?: InputMaybe<SortEnumType>;
  /** SEPA mandate id (e.g. from Adyen sepadirectdebit.mandateId). */
  mandateId?: InputMaybe<SortEnumType>;
  /** Adyen stored payment method token (recurring reference). */
  token?: InputMaybe<SortEnumType>;
};

/** Represents a payment for an accounting document, or an unallocated customer credit (no document). */
export type PaymentSortInput = {
  accountingDocument?: InputMaybe<AccountingDocumentSortInput>;
  /** Null for unallocated customer-credit pool rows (tenant-scoped, no invoice). */
  accountingDocumentId?: InputMaybe<SortEnumType>;
  /** Provider-specific data (e.g. Adyen PSP reference). Stored as jsonb. */
  additionalPropertiesJson?: InputMaybe<SortEnumType>;
  amountGross?: InputMaybe<SortEnumType>;
  amountNet?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  currencyCode?: InputMaybe<SortEnumType>;
  direction?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  organizationUnit?: InputMaybe<OrganizationUnitSortInput>;
  organizationUnitId?: InputMaybe<SortEnumType>;
  paymentDate?: InputMaybe<SortEnumType>;
  paymentGateway?: InputMaybe<PaymentGatewaySortInput>;
  paymentGatewayId?: InputMaybe<SortEnumType>;
  /**
   * External provider payment id (e.g. Adyen PSP reference). Stored inside
   * AdditionalPropertiesJson; first writer wins (set-if-absent) so a later
   * webhook never overwrites the original charge reference.
   */
  providerPaymentId?: InputMaybe<SortEnumType>;
  /** External reference (e.g. invoice number for provider payments). */
  reference?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  tenant?: InputMaybe<TenantSortInput>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** Represents the state of a payment. */
export type PaymentState =
  | 'COMPLETED'
  | 'FAILED'
  | 'PENDING'
  | 'REFUNDED'
  /** Refund submitted to provider but not yet confirmed via webhook. */
  | 'REFUND_PENDING';

export type PaymentStateOperationFilterInput = {
  eq?: InputMaybe<PaymentState>;
  in?: InputMaybe<Array<PaymentState>>;
  neq?: InputMaybe<PaymentState>;
  nin?: InputMaybe<Array<PaymentState>>;
};

/** Represents payment terms (e.g., Net 30, Net 60). */
export type PaymentTerm = {
  __typename: 'PaymentTerm';
  /** Optional short code for lookups (e.g. SEPA-DEFAULT). */
  code: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  days: Scalars['Int']['output'];
  /** Customer-facing payment instructions; frozen on the invoice (PDF + CII BT-20). */
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  paymentAccounts: Array<PaymentAccount>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents payment terms (e.g., Net 30, Net 60). */
export type PaymentTermFilterInput = {
  and?: InputMaybe<Array<PaymentTermFilterInput>>;
  /** Optional short code for lookups (e.g. SEPA-DEFAULT). */
  code?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  days?: InputMaybe<IntOperationFilterInput>;
  /** Customer-facing payment instructions; frozen on the invoice (PDF + CII BT-20). */
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PaymentTermFilterInput>>;
  paymentAccounts?: InputMaybe<ListFilterInputTypeOfPaymentAccountFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represents payment terms (e.g., Net 30, Net 60). */
export type PaymentTermSortInput = {
  /** Optional short code for lookups (e.g. SEPA-DEFAULT). */
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  days?: InputMaybe<SortEnumType>;
  /** Customer-facing payment instructions; frozen on the invoice (PDF + CII BT-20). */
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type PaymentTermsConnection = {
  __typename: 'PaymentTermsConnection';
  /** A list of edges. */
  edges: Maybe<Array<PaymentTermsEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<PaymentTerm>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PaymentTermsEdge = {
  __typename: 'PaymentTermsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PaymentTerm;
};

/** A connection to a list of items. */
export type PaymentsConnection = {
  __typename: 'PaymentsConnection';
  /** A list of edges. */
  edges: Maybe<Array<PaymentsEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<Payment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PaymentsEdge = {
  __typename: 'PaymentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Payment;
};

/** Represents a subscription plan. */
export type Plan = {
  __typename: 'Plan';
  amountGross: Scalars['Decimal']['output'];
  amountNet: Scalars['Decimal']['output'];
  code: Scalars['String']['output'];
  /**
   * Commitment period in months. How long the customer is locked into the contract (e.g., 12 months).
   * Used to calculate ExpiryDate when cancelling.
   */
  contractTermMonths: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /**
   * Billing cadence in months. How often invoices are generated (1=monthly, 3=quarterly, 12=annually).
   * Copied to IntervalMonths at subscription creation.
   */
  intervalMonths: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  noticePeriodMonths: Scalars['Int']['output'];
  skus: Array<Scalars['String']['output']>;
  status: PlanStatus;
  subscriptions: Array<Subscription>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents a subscription plan. */
export type PlanFilterInput = {
  amountGross?: InputMaybe<DecimalOperationFilterInput>;
  amountNet?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<PlanFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  /**
   * Commitment period in months. How long the customer is locked into the contract (e.g., 12 months).
   * Used to calculate ExpiryDate when cancelling.
   */
  contractTermMonths?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  /**
   * Billing cadence in months. How often invoices are generated (1=monthly, 3=quarterly, 12=annually).
   * Copied to IntervalMonths at subscription creation.
   */
  intervalMonths?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  noticePeriodMonths?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PlanFilterInput>>;
  skus?: InputMaybe<ListStringOperationFilterInput>;
  status?: InputMaybe<PlanStatusOperationFilterInput>;
  subscriptions?: InputMaybe<ListFilterInputTypeOfSubscriptionFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represents a subscription plan. */
export type PlanSortInput = {
  amountGross?: InputMaybe<SortEnumType>;
  amountNet?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  /**
   * Commitment period in months. How long the customer is locked into the contract (e.g., 12 months).
   * Used to calculate ExpiryDate when cancelling.
   */
  contractTermMonths?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * Billing cadence in months. How often invoices are generated (1=monthly, 3=quarterly, 12=annually).
   * Copied to IntervalMonths at subscription creation.
   */
  intervalMonths?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  noticePeriodMonths?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** Catalog lifecycle state for a Plan. */
export type PlanStatus = 'DISCONTINUED' | 'DRAFT' | 'PUBLISHED';

export type PlanStatusOperationFilterInput = {
  eq?: InputMaybe<PlanStatus>;
  in?: InputMaybe<Array<PlanStatus>>;
  neq?: InputMaybe<PlanStatus>;
  nin?: InputMaybe<Array<PlanStatus>>;
};

/** A connection to a list of items. */
export type PlansConnection = {
  __typename: 'PlansConnection';
  /** A list of edges. */
  edges: Maybe<Array<PlansEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<Plan>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PlansEdge = {
  __typename: 'PlansEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Plan;
};

/** Represents a product available for plans. */
export type Product = {
  __typename: 'Product';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** Comma-separated image URLs (matches existing ShopProduct convention). Multi-image entity is a future story. */
  images: Maybe<Scalars['String']['output']>;
  longDescription: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  /** List price including tax. Stored alongside PriceNet so catalog UIs can render without joining. */
  priceGross: Scalars['Decimal']['output'];
  /** List price excluding tax. Gross is computed at quote/invoice time via the active TaxRule. */
  priceNet: Scalars['Decimal']['output'];
  shortDescription: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  status: ProductStatus;
  type: ProductType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents a product available for plans. */
export type ProductFilterInput = {
  and?: InputMaybe<Array<ProductFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Comma-separated image URLs (matches existing ShopProduct convention). Multi-image entity is a future story. */
  images?: InputMaybe<StringOperationFilterInput>;
  longDescription?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  number?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductFilterInput>>;
  /** List price including tax. Stored alongside PriceNet so catalog UIs can render without joining. */
  priceGross?: InputMaybe<DecimalOperationFilterInput>;
  /** List price excluding tax. Gross is computed at quote/invoice time via the active TaxRule. */
  priceNet?: InputMaybe<DecimalOperationFilterInput>;
  shortDescription?: InputMaybe<StringOperationFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  sort?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<ProductStatusOperationFilterInput>;
  type?: InputMaybe<ProductTypeOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represents a product available for plans. */
export type ProductSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** Comma-separated image URLs (matches existing ShopProduct convention). Multi-image entity is a future story. */
  images?: InputMaybe<SortEnumType>;
  longDescription?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  number?: InputMaybe<SortEnumType>;
  /** List price including tax. Stored alongside PriceNet so catalog UIs can render without joining. */
  priceGross?: InputMaybe<SortEnumType>;
  /** List price excluding tax. Gross is computed at quote/invoice time via the active TaxRule. */
  priceNet?: InputMaybe<SortEnumType>;
  shortDescription?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  sort?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/**
 * Catalog lifecycle state for a Product.
 * Public catalog queries filter to Published.
 */
export type ProductStatus = 'DISCONTINUED' | 'DRAFT' | 'PUBLISHED';

export type ProductStatusOperationFilterInput = {
  eq?: InputMaybe<ProductStatus>;
  in?: InputMaybe<Array<ProductStatus>>;
  neq?: InputMaybe<ProductStatus>;
  nin?: InputMaybe<Array<ProductStatus>>;
};

/** Represents the type of a product. */
export type ProductType =
  | 'CARD_TERMINAL'
  | 'CARD_TERMINAL_ACCESSORY'
  /** Digital/downloadable product. */
  | 'DIGITAL'
  /** License key. */
  | 'LICENSE'
  /** Physical POS System. */
  | 'LICENSE_ADD_ON'
  /** Physical product. */
  | 'PHYSICAL'
  | 'POS_ACCESSORY'
  | 'POS_ADD_ON'
  | 'POS_SYSTEM'
  /** Service or subscription. */
  | 'SERVICE';

export type ProductTypeOperationFilterInput = {
  eq?: InputMaybe<ProductType>;
  in?: InputMaybe<Array<ProductType>>;
  neq?: InputMaybe<ProductType>;
  nin?: InputMaybe<Array<ProductType>>;
};

/** A connection to a list of items. */
export type ProductsConnection = {
  __typename: 'ProductsConnection';
  /** A list of edges. */
  edges: Maybe<Array<ProductsEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<Product>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductsEdge = {
  __typename: 'ProductsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Product;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type Query = {
  __typename: 'Query';
  /** Gets a single accounting document by ID. */
  accountingDocument: Maybe<AccountingDocument>;
  /**
   * Gets accounting documents with pagination, filtering, sorting, and projection.
   * Super Admin: all documents. Reseller: documents for their tenants.
   */
  accountingDocuments: Maybe<AccountingDocumentsConnection>;
  /** Gets a single app version by id. */
  appVersion: Maybe<AppVersion>;
  /** Global version policy from app settings. */
  appVersionPolicy: AppVersionPolicy;
  /** Lists app versions with pagination, filtering, and sorting. */
  appVersions: Maybe<AppVersionsConnection>;
  /**
   * Active, reseller-visible coupons. Requires the caller to have a ResellerId claim;
   * callers without one (e.g. regular tenant users) get an empty result.
   */
  availableCoupons: Maybe<AvailableCouponsConnection>;
  coupon: Maybe<Coupon>;
  coupons: Maybe<CouponsConnection>;
  /** Gets the tenant for the authenticated user's effective TenantId (JWT claim or override header). */
  currentTenant: Maybe<Tenant>;
  invitation: Maybe<Invitation>;
  invitations: Maybe<InvitationsConnection>;
  /**
   * Gets a single licence by ID.
   * Super Admin: any licence. Reseller: licence for a tenant with matching ResellerId. Otherwise: own tenant only.
   */
  licence: Maybe<Licence>;
  /**
   * Gets licences with pagination, filtering, sorting, and projection.
   * Super Admin: all licences (optional databaseId, tenantId, organizationId).
   * Reseller: licences for their tenants (same optional filters).
   * Default: current tenant only; optional databaseId filter.
   */
  licences: Maybe<LicencesConnection>;
  /**
   * Main promotional coupon from app setting MainCoupon (coupon id).
   * Returns null when unset, invalid, inactive, expired, or not a percentage discount.
   */
  mainCoupon: Maybe<MainCouponPromo>;
  order: Maybe<Order>;
  /** Gets a single organization by ID. */
  organization: Maybe<Organization>;
  /** Gets a single organization address by ID. */
  organizationAddress: Maybe<OrganizationAddress>;
  /** Gets organization addresses with pagination, filtering, sorting, and projection. */
  organizationAddresses: Maybe<OrganizationAddressesConnection>;
  /** Gets a single organization contact by ID. */
  organizationContact: Maybe<OrganizationContact>;
  /** Gets organization contacts with pagination, filtering, sorting, and projection. */
  organizationContacts: Maybe<OrganizationContactsConnection>;
  /**
   * Gets a single organization unit by ID.
   * Super Admin: any organization unit. Reseller: own tenant or child-tenant organization units.
   */
  organizationUnit: Maybe<OrganizationUnit>;
  /**
   * Gets organization units with pagination, filtering, sorting, and projection.
   * Super Admin: all organization units. Reseller: organization units for their tenants.
   */
  organizationUnits: Maybe<OrganizationUnitsConnection>;
  /**
   * Gets organizations with pagination, filtering, sorting, and projection.
   * Super Admin: all organizations. Reseller: organizations for their tenants.
   */
  organizations: Maybe<OrganizationsConnection>;
  /** Gets a single payment by ID. */
  payment: Maybe<Payment>;
  /** Gets a single payment account by ID. */
  paymentAccount: Maybe<PaymentAccount>;
  /**
   * Gets payment accounts with pagination, filtering, sorting, and projection.
   * Super Admin: all payment accounts. Reseller: payment accounts for their tenants.
   */
  paymentAccounts: Maybe<PaymentAccountsConnection>;
  /** Gets a single payment gateway by ID. */
  paymentGateway: Maybe<PaymentGateway>;
  /** Gets payment gateways with pagination, filtering, sorting, and projection. */
  paymentGateways: Maybe<PaymentGatewaysConnection>;
  /** Gets a single payment term by ID. */
  paymentTerm: Maybe<PaymentTerm>;
  /** Gets payment terms with pagination, filtering, sorting, and projection. */
  paymentTerms: Maybe<PaymentTermsConnection>;
  /**
   * Gets payments with pagination, filtering, sorting, and projection.
   * Super Admin: all payments. Reseller: payments for their tenants.
   */
  payments: Maybe<PaymentsConnection>;
  /** Gets a single plan by ID. */
  plan: Maybe<Plan>;
  /** Gets plans with pagination, filtering, sorting, and projection. */
  plans: Maybe<PlansConnection>;
  /** Gets a single product by ID. */
  product: Maybe<Product>;
  /** Gets products with pagination, filtering, sorting, and projection. */
  products: Maybe<ProductsConnection>;
  /** Gets a single resource by id (includes content for download/preview). */
  resource: Maybe<Resource>;
  /** Lists all resources ordered by sort order, then title. */
  resources: Array<Resource>;
  /** Latest resumable Drop-in order for an org unit, if any. */
  resumableOrder: Maybe<Order>;
  /** Gets a single subscription by ID. */
  subscription: Maybe<Subscription>;
  /**
   * Gets subscriptions with pagination, filtering, sorting, and projection.
   * Super Admin: all subscriptions (optionally filtered by tenantId).
   * Reseller: subscriptions for tenants with matching ResellerId.
   * Regular user: only their tenant's subscriptions.
   */
  subscriptions: Maybe<SubscriptionsConnection>;
  /** Gets a single tax rule by ID. */
  taxRule: Maybe<TaxRule>;
  /** Gets tax rules with pagination, filtering, sorting, and projection. */
  taxRules: Maybe<TaxRulesConnection>;
  /** Gets a single tenant by ID. Allowed only if Super Admin or (Reseller and tenant.ParentId matches). */
  tenant: Maybe<Tenant>;
  /** Gets tenants for Reseller Portal. Super Admin sees all (optional resellerId filter); Reseller sees only their tenants. */
  tenants: Maybe<TenantsConnection>;
  user: UserInfoResult;
  validateCoupon: Coupon;
  webhookQueues: Maybe<WebhookQueuesConnection>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryAccountingDocumentArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryAccountingDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AccountingDocumentSortInput>>;
  resellerTenantId?: InputMaybe<Scalars['UUID']['input']>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  where?: InputMaybe<AccountingDocumentFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryAppVersionArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryAppVersionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AppVersionSortInput>>;
  where?: InputMaybe<AppVersionFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryAvailableCouponsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CouponSortInput>>;
  where?: InputMaybe<CouponFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryCouponArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryCouponsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CouponSortInput>>;
  where?: InputMaybe<CouponFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryInvitationArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InvitationSortInput>>;
  where?: InputMaybe<InvitationFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryLicenceArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryLicencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LicenceSortInput>>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  where?: InputMaybe<LicenceFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryOrderArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryOrganizationArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryOrganizationAddressArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryOrganizationAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrganizationAddressSortInput>>;
  where?: InputMaybe<OrganizationAddressFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryOrganizationContactArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryOrganizationContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrganizationContactSortInput>>;
  where?: InputMaybe<OrganizationContactFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryOrganizationUnitArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryOrganizationUnitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrganizationUnitSortInput>>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  where?: InputMaybe<OrganizationUnitFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrganizationSortInput>>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  where?: InputMaybe<OrganizationFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryPaymentArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryPaymentAccountArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryPaymentAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PaymentAccountSortInput>>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  where?: InputMaybe<PaymentAccountFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryPaymentGatewayArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryPaymentGatewaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PaymentGatewaySortInput>>;
  where?: InputMaybe<PaymentGatewayFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryPaymentTermArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryPaymentTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PaymentTermSortInput>>;
  where?: InputMaybe<PaymentTermFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PaymentSortInput>>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  where?: InputMaybe<PaymentFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryPlanArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PlanSortInput>>;
  where?: InputMaybe<PlanFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryProductArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductSortInput>>;
  where?: InputMaybe<ProductFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryResourceArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryResumableOrderArgs = {
  organizationUnitId: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QuerySubscriptionArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QuerySubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SubscriptionSortInput>>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  where?: InputMaybe<SubscriptionFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryTaxRuleArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryTaxRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TaxRuleSortInput>>;
  where?: InputMaybe<TaxRuleFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryTenantArgs = {
  id: Scalars['UUID']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryTenantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TenantSortInput>>;
  resellerId?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TenantFilterInput>;
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryValidateCouponArgs = {
  code: Scalars['String']['input'];
  items: Array<SubscriptionSkuLineInput>;
  planCode: Scalars['String']['input'];
};

/**
 * GraphQL query that proxies the auth server's /connect/userinfo response.
 * Tenant provisioning runs in this resolver (EnsureTenantAsync) so the first call after login provisions the tenant.
 */
export type QueryWebhookQueuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<WebhookQueueSortInput>>;
  where?: InputMaybe<WebhookQueueFilterInput>;
};

export type RefundPaymentError = EntityNotFoundError | InvalidStateTransitionError;

export type RefundPaymentInput = {
  paymentId: Scalars['UUID']['input'];
};

export type RefundPaymentPayload = {
  __typename: 'RefundPaymentPayload';
  errors: Maybe<Array<RefundPaymentError>>;
  payment: Maybe<Payment>;
};

export type RemoveCouponFromSubscriptionError = EntityNotFoundError;

export type RemoveCouponFromSubscriptionInput = {
  id: Scalars['UUID']['input'];
};

export type RemoveCouponFromSubscriptionPayload = {
  __typename: 'RemoveCouponFromSubscriptionPayload';
  errors: Maybe<Array<RemoveCouponFromSubscriptionError>>;
  subscription: Maybe<Subscription>;
};

export type ReorderResourcesError = EntityNotFoundError;

export type ReorderResourcesInput = {
  items: Array<ResourceSortItemInput>;
};

export type ReorderResourcesPayload = {
  __typename: 'ReorderResourcesPayload';
  errors: Maybe<Array<ReorderResourcesError>>;
  resource: Maybe<Array<Resource>>;
};

export type ReplayAllFailedWebhooksInput = {
  provider?: InputMaybe<Scalars['String']['input']>;
};

export type ReplayAllFailedWebhooksPayload = {
  __typename: 'ReplayAllFailedWebhooksPayload';
  int: Maybe<Scalars['Int']['output']>;
};

export type ReplayFailedWebhookError = EntityNotFoundError | InvalidStateTransitionError;

export type ReplayFailedWebhookInput = {
  id: Scalars['UUID']['input'];
};

export type ReplayFailedWebhookPayload = {
  __typename: 'ReplayFailedWebhookPayload';
  errors: Maybe<Array<ReplayFailedWebhookError>>;
  webhookQueue: Maybe<WebhookQueue>;
};

export type ResendInvitationError = EntityNotFoundError | InvalidStateTransitionError;

export type ResendInvitationInput = {
  id: Scalars['UUID']['input'];
};

export type ResendInvitationPayload = {
  __typename: 'ResendInvitationPayload';
  errors: Maybe<Array<ResendInvitationError>>;
  invitation: Maybe<Invitation>;
};

export type ResendInvoiceWithRefreshedAddressError = EntityNotFoundError | InvalidOperationError;

export type ResendInvoiceWithRefreshedAddressInput = {
  invoiceId: Scalars['UUID']['input'];
};

export type ResendInvoiceWithRefreshedAddressPayload = {
  __typename: 'ResendInvoiceWithRefreshedAddressPayload';
  accountingDocument: Maybe<AccountingDocument>;
  errors: Maybe<Array<ResendInvoiceWithRefreshedAddressError>>;
};

/** Global file (PDF or image) in the portal resource library. */
export type Resource = {
  __typename: 'Resource';
  contentBase64: Maybe<Scalars['String']['output']>;
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  fileSizeBytes: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  previewBase64: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ResourceSortItemInput = {
  id: Scalars['UUID']['input'];
  sortOrder: Scalars['Int']['input'];
};

export type ResumeOrderError = EntityNotFoundError;

export type ResumeOrderInput = {
  countryCode: Scalars['String']['input'];
  orderId: Scalars['UUID']['input'];
  redirectUri: Scalars['String']['input'];
};

export type ResumeOrderPayload = {
  __typename: 'ResumeOrderPayload';
  checkoutResult: Maybe<CheckoutResult>;
  errors: Maybe<Array<ResumeOrderError>>;
};

export type RetryPaymentError =
  | EntityNotFoundError
  | InvalidStateTransitionError
  | MandateNotFoundError;

export type RetryPaymentInput = {
  paymentId: Scalars['UUID']['input'];
};

export type RetryPaymentPayload = {
  __typename: 'RetryPaymentPayload';
  errors: Maybe<Array<RetryPaymentError>>;
  payment: Maybe<Payment>;
};

export type RevokeInvitationError = EntityNotFoundError | InvalidStateTransitionError;

export type RevokeInvitationInput = {
  id: Scalars['UUID']['input'];
};

export type RevokeInvitationPayload = {
  __typename: 'RevokeInvitationPayload';
  boolean: Maybe<Scalars['Boolean']['output']>;
  errors: Maybe<Array<RevokeInvitationError>>;
};

export type SortEnumType = 'ASC' | 'DESC';

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a subscription for an organization unit. */
export type Subscription = {
  __typename: 'Subscription';
  accountingDocuments: Array<AccountingDocument>;
  activationDate: Maybe<Scalars['DateTime']['output']>;
  /** Extra, non-schematised per-subscription data stored as jsonb. Reserved for future use. */
  additionalPropertiesJson: Maybe<Scalars['String']['output']>;
  amountGross: Maybe<Scalars['Decimal']['output']>;
  amountNet: Maybe<Scalars['Decimal']['output']>;
  /** Frozen coupon terms at apply time (code, type, duration, discount, scoping). */
  appliedCouponSnapshotJson: Maybe<Scalars['String']['output']>;
  /**
   * Date the customer asked to cancel. State becomes Cancelled immediately;
   * licences stay valid until ExpiryDate.
   */
  cancellationDate: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currencyCode: Maybe<Scalars['String']['output']>;
  currentTermEndDate: Maybe<Scalars['DateTime']['output']>;
  currentTermStartDate: Maybe<Scalars['DateTime']['output']>;
  /**
   * Effective end-of-life. Set on cancel = CancellationDate + remaining
   * ContractTermMonths; the expiration job flips the sub to Expired and
   * revokes licences when reached. Null while the sub is still in its commit term.
   */
  expiryDate: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  /** Billing cadence in months. Set at subscription creation; term advancement reads this value. */
  intervalMonths: Scalars['Int']['output'];
  number: Scalars['String']['output'];
  organizationUnit: OrganizationUnit;
  organizationUnitId: Scalars['UUID']['output'];
  paymentAccount: Maybe<PaymentAccount>;
  paymentAccountId: Maybe<Scalars['UUID']['output']>;
  plan: Plan;
  planId: Scalars['UUID']['output'];
  state: SubscriptionState;
  subscriptionItems: Array<SubscriptionItem>;
  tenant: Tenant;
  tenantId: Scalars['UUID']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Represents a subscription for an organization unit. */
export type SubscriptionFilterInput = {
  accountingDocuments?: InputMaybe<ListFilterInputTypeOfAccountingDocumentFilterInput>;
  activationDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Extra, non-schematised per-subscription data stored as jsonb. Reserved for future use. */
  additionalPropertiesJson?: InputMaybe<StringOperationFilterInput>;
  amountGross?: InputMaybe<DecimalOperationFilterInput>;
  amountNet?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<SubscriptionFilterInput>>;
  /** Frozen coupon terms at apply time (code, type, duration, discount, scoping). */
  appliedCouponSnapshotJson?: InputMaybe<StringOperationFilterInput>;
  /**
   * Date the customer asked to cancel. State becomes Cancelled immediately;
   * licences stay valid until ExpiryDate.
   */
  cancellationDate?: InputMaybe<DateTimeOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  currencyCode?: InputMaybe<StringOperationFilterInput>;
  currentTermEndDate?: InputMaybe<DateTimeOperationFilterInput>;
  currentTermStartDate?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * Effective end-of-life. Set on cancel = CancellationDate + remaining
   * ContractTermMonths; the expiration job flips the sub to Expired and
   * revokes licences when reached. Null while the sub is still in its commit term.
   */
  expiryDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Billing cadence in months. Set at subscription creation; term advancement reads this value. */
  intervalMonths?: InputMaybe<IntOperationFilterInput>;
  number?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SubscriptionFilterInput>>;
  organizationUnit?: InputMaybe<OrganizationUnitFilterInput>;
  organizationUnitId?: InputMaybe<UuidOperationFilterInput>;
  paymentAccount?: InputMaybe<PaymentAccountFilterInput>;
  paymentAccountId?: InputMaybe<UuidOperationFilterInput>;
  plan?: InputMaybe<PlanFilterInput>;
  planId?: InputMaybe<UuidOperationFilterInput>;
  state?: InputMaybe<SubscriptionStateOperationFilterInput>;
  subscriptionItems?: InputMaybe<ListFilterInputTypeOfSubscriptionItemFilterInput>;
  tenant?: InputMaybe<TenantFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represents an item within a subscription. */
export type SubscriptionItem = {
  __typename: 'SubscriptionItem';
  createdAt: Scalars['DateTime']['output'];
  currencyCode: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  licence: Maybe<Licence>;
  quantity: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  subscription: Subscription;
  subscriptionId: Scalars['UUID']['output'];
  unitPriceGross: Scalars['Decimal']['output'];
  unitPriceNet: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents an item within a subscription. */
export type SubscriptionItemFilterInput = {
  and?: InputMaybe<Array<SubscriptionItemFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  currencyCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  licence?: InputMaybe<LicenceFilterInput>;
  or?: InputMaybe<Array<SubscriptionItemFilterInput>>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  subscription?: InputMaybe<SubscriptionFilterInput>;
  subscriptionId?: InputMaybe<UuidOperationFilterInput>;
  unitPriceGross?: InputMaybe<DecimalOperationFilterInput>;
  unitPriceNet?: InputMaybe<DecimalOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represents an item within a subscription. */
export type SubscriptionItemSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  currencyCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  licence?: InputMaybe<LicenceSortInput>;
  quantity?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  subscription?: InputMaybe<SubscriptionSortInput>;
  subscriptionId?: InputMaybe<SortEnumType>;
  unitPriceGross?: InputMaybe<SortEnumType>;
  unitPriceNet?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** SKU line for subscription creation (GraphQL input + billing service). */
export type SubscriptionSkuLineInput = {
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

/** Represents a subscription for an organization unit. */
export type SubscriptionSortInput = {
  activationDate?: InputMaybe<SortEnumType>;
  /** Extra, non-schematised per-subscription data stored as jsonb. Reserved for future use. */
  additionalPropertiesJson?: InputMaybe<SortEnumType>;
  amountGross?: InputMaybe<SortEnumType>;
  amountNet?: InputMaybe<SortEnumType>;
  /** Frozen coupon terms at apply time (code, type, duration, discount, scoping). */
  appliedCouponSnapshotJson?: InputMaybe<SortEnumType>;
  /**
   * Date the customer asked to cancel. State becomes Cancelled immediately;
   * licences stay valid until ExpiryDate.
   */
  cancellationDate?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  currencyCode?: InputMaybe<SortEnumType>;
  currentTermEndDate?: InputMaybe<SortEnumType>;
  currentTermStartDate?: InputMaybe<SortEnumType>;
  /**
   * Effective end-of-life. Set on cancel = CancellationDate + remaining
   * ContractTermMonths; the expiration job flips the sub to Expired and
   * revokes licences when reached. Null while the sub is still in its commit term.
   */
  expiryDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** Billing cadence in months. Set at subscription creation; term advancement reads this value. */
  intervalMonths?: InputMaybe<SortEnumType>;
  number?: InputMaybe<SortEnumType>;
  organizationUnit?: InputMaybe<OrganizationUnitSortInput>;
  organizationUnitId?: InputMaybe<SortEnumType>;
  paymentAccount?: InputMaybe<PaymentAccountSortInput>;
  paymentAccountId?: InputMaybe<SortEnumType>;
  plan?: InputMaybe<PlanSortInput>;
  planId?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  tenant?: InputMaybe<TenantSortInput>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** Represents the state of a subscription. */
export type SubscriptionState =
  | 'ACTIVE'
  | 'CANCELLED'
  | 'EXPIRED'
  /** i.e. Created but mandate not yet confirmed (e.g. awaiting billing_request.fulfilled). */
  | 'PENDING'
  | 'SUSPENDED';

export type SubscriptionStateOperationFilterInput = {
  eq?: InputMaybe<SubscriptionState>;
  in?: InputMaybe<Array<SubscriptionState>>;
  neq?: InputMaybe<SubscriptionState>;
  nin?: InputMaybe<Array<SubscriptionState>>;
};

/** A connection to a list of items. */
export type SubscriptionsConnection = {
  __typename: 'SubscriptionsConnection';
  /** A list of edges. */
  edges: Maybe<Array<SubscriptionsEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<Subscription>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubscriptionsEdge = {
  __typename: 'SubscriptionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Subscription;
};

export type SuspendSubscriptionError = EntityNotFoundError | InvalidStateTransitionError;

export type SuspendSubscriptionInput = {
  id: Scalars['UUID']['input'];
};

export type SuspendSubscriptionPayload = {
  __typename: 'SuspendSubscriptionPayload';
  errors: Maybe<Array<SuspendSubscriptionError>>;
  subscription: Maybe<Subscription>;
};

/** Represents a tax rule configuration. */
export type TaxRule = {
  __typename: 'TaxRule';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  paymentAccounts: Array<PaymentAccount>;
  printText: Maybe<Scalars['String']['output']>;
  taxRate: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents a tax rule configuration. */
export type TaxRuleFilterInput = {
  and?: InputMaybe<Array<TaxRuleFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TaxRuleFilterInput>>;
  paymentAccounts?: InputMaybe<ListFilterInputTypeOfPaymentAccountFilterInput>;
  printText?: InputMaybe<StringOperationFilterInput>;
  taxRate?: InputMaybe<DecimalOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represents a tax rule configuration. */
export type TaxRuleSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  printText?: InputMaybe<SortEnumType>;
  taxRate?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type TaxRulesConnection = {
  __typename: 'TaxRulesConnection';
  /** A list of edges. */
  edges: Maybe<Array<TaxRulesEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<TaxRule>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TaxRulesEdge = {
  __typename: 'TaxRulesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TaxRule;
};

/** Represents a tenant in the multi-tenant system. */
export type Tenant = {
  __typename: 'Tenant';
  createdAt: Scalars['DateTime']['output'];
  discountPercent: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<Tenant>;
  parentId: Maybe<Scalars['UUID']['output']>;
  resellerId: Maybe<Scalars['Int']['output']>;
  /** Base64 data-URI logo for reseller branding (customer invite emails, etc.). */
  resellerLogo: Maybe<Scalars['String']['output']>;
  status: TenantStatus;
  tenantNumber: Scalars['Int']['output'];
  type: TenantType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents a tenant in the multi-tenant system. */
export type TenantFilterInput = {
  and?: InputMaybe<Array<TenantFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  discountPercent?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TenantFilterInput>>;
  parent?: InputMaybe<TenantFilterInput>;
  parentId?: InputMaybe<UuidOperationFilterInput>;
  resellerId?: InputMaybe<IntOperationFilterInput>;
  /** Base64 data-URI logo for reseller branding (customer invite emails, etc.). */
  resellerLogo?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<TenantStatusOperationFilterInput>;
  tenantNumber?: InputMaybe<IntOperationFilterInput>;
  type?: InputMaybe<TenantTypeOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represents a tenant in the multi-tenant system. */
export type TenantSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  discountPercent?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parent?: InputMaybe<TenantSortInput>;
  parentId?: InputMaybe<SortEnumType>;
  resellerId?: InputMaybe<SortEnumType>;
  /** Base64 data-URI logo for reseller branding (customer invite emails, etc.). */
  resellerLogo?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantNumber?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type TenantStatus = 'ACTIVE' | 'INACTIVE' | 'SUSPENDED';

export type TenantStatusOperationFilterInput = {
  eq?: InputMaybe<TenantStatus>;
  in?: InputMaybe<Array<TenantStatus>>;
  neq?: InputMaybe<TenantStatus>;
  nin?: InputMaybe<Array<TenantStatus>>;
};

export type TenantType = 'CUSTOMER' | 'RESELLER';

export type TenantTypeOperationFilterInput = {
  eq?: InputMaybe<TenantType>;
  in?: InputMaybe<Array<TenantType>>;
  neq?: InputMaybe<TenantType>;
  nin?: InputMaybe<Array<TenantType>>;
};

/** A connection to a list of items. */
export type TenantsConnection = {
  __typename: 'TenantsConnection';
  /** A list of edges. */
  edges: Maybe<Array<TenantsEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<Tenant>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TenantsEdge = {
  __typename: 'TenantsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Tenant;
};

export type UnsignedByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['UnsignedByte']['input']>;
  gt?: InputMaybe<Scalars['UnsignedByte']['input']>;
  gte?: InputMaybe<Scalars['UnsignedByte']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedByte']['input']>>>;
  lt?: InputMaybe<Scalars['UnsignedByte']['input']>;
  lte?: InputMaybe<Scalars['UnsignedByte']['input']>;
  neq?: InputMaybe<Scalars['UnsignedByte']['input']>;
  ngt?: InputMaybe<Scalars['UnsignedByte']['input']>;
  ngte?: InputMaybe<Scalars['UnsignedByte']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UnsignedByte']['input']>>>;
  nlt?: InputMaybe<Scalars['UnsignedByte']['input']>;
  nlte?: InputMaybe<Scalars['UnsignedByte']['input']>;
};

export type UpdateAppVersionError = EntityNotFoundError | EntityReferencedError;

export type UpdateAppVersionInput = {
  id: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseDate?: InputMaybe<Scalars['DateTime']['input']>;
  releaseNotes?: InputMaybe<Scalars['String']['input']>;
  versionCode?: InputMaybe<Scalars['Int']['input']>;
  versionName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAppVersionPayload = {
  __typename: 'UpdateAppVersionPayload';
  appVersion: Maybe<AppVersion>;
  errors: Maybe<Array<UpdateAppVersionError>>;
};

export type UpdateAppVersionPolicyInput = {
  requiredMinVersion?: InputMaybe<Scalars['String']['input']>;
  suggestedMinVersion?: InputMaybe<Scalars['String']['input']>;
  updateStoreUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAppVersionPolicyPayload = {
  __typename: 'UpdateAppVersionPolicyPayload';
  appVersionPolicy: Maybe<AppVersionPolicy>;
};

export type UpdateCouponError = EntityNotFoundError;

export type UpdateCouponInput = {
  allowedPlanCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedProductSkus?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['UUID']['input'];
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CouponStatus>;
  usageType?: InputMaybe<CouponUsageType>;
};

export type UpdateCouponPayload = {
  __typename: 'UpdateCouponPayload';
  coupon: Maybe<Coupon>;
  errors: Maybe<Array<UpdateCouponError>>;
};

export type UpdateLicenceStateError = EntityNotFoundError;

export type UpdateLicenceStateInput = {
  id: Scalars['UUID']['input'];
  state: LicenceState;
};

export type UpdateLicenceStatePayload = {
  __typename: 'UpdateLicenceStatePayload';
  errors: Maybe<Array<UpdateLicenceStateError>>;
  licence: Maybe<Licence>;
};

export type UpdateMainCouponInput = {
  id: Scalars['UUID']['input'];
};

export type UpdateMainCouponPayload = {
  __typename: 'UpdateMainCouponPayload';
  boolean: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateOrderError = EntityNotFoundError;

export type UpdateOrderInput = {
  countryCode: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  items: Array<SubscriptionSkuLineInput>;
  orderId: Scalars['UUID']['input'];
  planId: Scalars['UUID']['input'];
  redirectUri: Scalars['String']['input'];
  taxRuleId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateOrderPayload = {
  __typename: 'UpdateOrderPayload';
  checkoutResult: Maybe<CheckoutResult>;
  errors: Maybe<Array<UpdateOrderError>>;
};

export type UpdateOrganizationAddressError = EntityNotFoundError;

export type UpdateOrganizationAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AddressType>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationAddressPayload = {
  __typename: 'UpdateOrganizationAddressPayload';
  errors: Maybe<Array<UpdateOrganizationAddressError>>;
  organizationAddress: Maybe<OrganizationAddress>;
};

export type UpdateOrganizationContactError = EntityNotFoundError;

export type UpdateOrganizationContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationContactPayload = {
  __typename: 'UpdateOrganizationContactPayload';
  errors: Maybe<Array<UpdateOrganizationContactError>>;
  organizationContact: Maybe<OrganizationContact>;
};

export type UpdateOrganizationError = EntityNotFoundError;

export type UpdateOrganizationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrganizationStatus>;
};

export type UpdateOrganizationPayload = {
  __typename: 'UpdateOrganizationPayload';
  errors: Maybe<Array<UpdateOrganizationError>>;
  organization: Maybe<Organization>;
};

export type UpdateOrganizationUnitError = EntityNotFoundError;

export type UpdateOrganizationUnitInput = {
  additionalPropertiesJson?: InputMaybe<Scalars['String']['input']>;
  appType?: InputMaybe<Scalars['String']['input']>;
  branchType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOrganizationUnitPayload = {
  __typename: 'UpdateOrganizationUnitPayload';
  errors: Maybe<Array<UpdateOrganizationUnitError>>;
  organizationUnit: Maybe<OrganizationUnit>;
};

export type UpdatePaymentAccountError = EntityNotFoundError;

export type UpdatePaymentAccountInput = {
  id: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paymentGatewayId?: InputMaybe<Scalars['UUID']['input']>;
  paymentTermId?: InputMaybe<Scalars['UUID']['input']>;
  taxRuleId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdatePaymentAccountPayload = {
  __typename: 'UpdatePaymentAccountPayload';
  errors: Maybe<Array<UpdatePaymentAccountError>>;
  paymentAccount: Maybe<PaymentAccount>;
};

export type UpdatePaymentGatewayError = EntityNotFoundError;

export type UpdatePaymentGatewayInput = {
  id: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentGatewayPayload = {
  __typename: 'UpdatePaymentGatewayPayload';
  errors: Maybe<Array<UpdatePaymentGatewayError>>;
  paymentGateway: Maybe<PaymentGateway>;
};

export type UpdatePaymentTermError = EntityNotFoundError;

export type UpdatePaymentTermInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentTermPayload = {
  __typename: 'UpdatePaymentTermPayload';
  errors: Maybe<Array<UpdatePaymentTermError>>;
  paymentTerm: Maybe<PaymentTerm>;
};

export type UpdatePlanError = EntityNotFoundError;

export type UpdatePlanInput = {
  amountGross?: InputMaybe<Scalars['Decimal']['input']>;
  amountNet?: InputMaybe<Scalars['Decimal']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  contractTermMonths?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  intervalMonths?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skus?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<PlanStatus>;
};

export type UpdatePlanPayload = {
  __typename: 'UpdatePlanPayload';
  errors: Maybe<Array<UpdatePlanError>>;
  plan: Maybe<Plan>;
};

export type UpdateProductError = EntityNotFoundError;

export type UpdateProductInput = {
  id: Scalars['UUID']['input'];
  longDescription?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ProductType>;
};

export type UpdateProductPayload = {
  __typename: 'UpdateProductPayload';
  errors: Maybe<Array<UpdateProductError>>;
  product: Maybe<Product>;
};

export type UpdateResourceError = EntityNotFoundError | InvalidOperationError;

export type UpdateResourceInput = {
  contentBase64?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateResourcePayload = {
  __typename: 'UpdateResourcePayload';
  errors: Maybe<Array<UpdateResourceError>>;
  resource: Maybe<Resource>;
};

export type UpdateSubscriptionPaymentAccountError = EntityNotFoundError;

export type UpdateSubscriptionPaymentAccountInput = {
  id: Scalars['UUID']['input'];
  paymentAccountId: Scalars['UUID']['input'];
};

export type UpdateSubscriptionPaymentAccountPayload = {
  __typename: 'UpdateSubscriptionPaymentAccountPayload';
  errors: Maybe<Array<UpdateSubscriptionPaymentAccountError>>;
  subscription: Maybe<Subscription>;
};

export type UpdateTaxRuleError = EntityNotFoundError;

export type UpdateTaxRuleInput = {
  id: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  printText?: InputMaybe<Scalars['String']['input']>;
  taxRate?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateTaxRulePayload = {
  __typename: 'UpdateTaxRulePayload';
  errors: Maybe<Array<UpdateTaxRuleError>>;
  taxRule: Maybe<TaxRule>;
};

export type UpdateTenantDiscountPercentError = EntityNotFoundError | InvalidOperationError;

export type UpdateTenantDiscountPercentInput = {
  discountPercent: Scalars['Decimal']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type UpdateTenantDiscountPercentPayload = {
  __typename: 'UpdateTenantDiscountPercentPayload';
  errors: Maybe<Array<UpdateTenantDiscountPercentError>>;
  tenant: Maybe<Tenant>;
};

export type UpdateTenantResellerLogoError = EntityNotFoundError | InvalidOperationError;

export type UpdateTenantResellerLogoInput = {
  resellerLogo?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type UpdateTenantResellerLogoPayload = {
  __typename: 'UpdateTenantResellerLogoPayload';
  errors: Maybe<Array<UpdateTenantResellerLogoError>>;
  tenant: Maybe<Tenant>;
};

/**
 * Exact shape of the auth server's /connect/userinfo response.
 * Used to deserialize from the auth server and forward from the GraphQL user query with the same JSON syntax.
 */
export type UserInfoResult = {
  __typename: 'UserInfoResult';
  active: Maybe<Scalars['String']['output']>;
  approveStatus: Maybe<Scalars['Int']['output']>;
  country: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  familyName: Maybe<Scalars['String']['output']>;
  givenName: Maybe<Scalars['String']['output']>;
  middleName: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  phoneNumberVerified: Maybe<Scalars['Boolean']['output']>;
  picture: Maybe<Scalars['String']['output']>;
  resellerId: Maybe<Scalars['String']['output']>;
  role: Maybe<Array<Scalars['String']['output']>>;
  sub: Scalars['String']['output'];
  username: Maybe<Scalars['String']['output']>;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

/**
 * Durable webhook inbox. One row per incoming HTTP request.
 * The background processing job picks up Pending rows and delegates to the provider-specific handler.
 * Provider-agnostic: works for Adyen, Stripe, Fiskaly, SendGrid, or any future integration.
 */
export type WebhookQueue = {
  __typename: 'WebhookQueue';
  attempts: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Most recent error message from a failed processing attempt. Cleared on eventual success. */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** Request headers as JSON. Stored for background signature verification. */
  headers: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** Full raw request body. Kept for processing, replay, and diagnostics. */
  payload: Maybe<Scalars['String']['output']>;
  processedAt: Maybe<Scalars['DateTime']['output']>;
  /** Provider name (e.g. "adyen", "stripe", "fiskaly"). Lower-cased by convention. */
  provider: Scalars['String']['output'];
  /** Dedup key with Provider. Null when the ingestor could not extract an id. */
  providerEventId: Maybe<Scalars['String']['output']>;
  status: WebhookQueueStatus;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Durable webhook inbox. One row per incoming HTTP request.
 * The background processing job picks up Pending rows and delegates to the provider-specific handler.
 * Provider-agnostic: works for Adyen, Stripe, Fiskaly, SendGrid, or any future integration.
 */
export type WebhookQueueFilterInput = {
  and?: InputMaybe<Array<WebhookQueueFilterInput>>;
  attempts?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Most recent error message from a failed processing attempt. Cleared on eventual success. */
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  /** Request headers as JSON. Stored for background signature verification. */
  headers?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<WebhookQueueFilterInput>>;
  /** Full raw request body. Kept for processing, replay, and diagnostics. */
  payload?: InputMaybe<StringOperationFilterInput>;
  processedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Provider name (e.g. "adyen", "stripe", "fiskaly"). Lower-cased by convention. */
  provider?: InputMaybe<StringOperationFilterInput>;
  /** Dedup key with Provider. Null when the ingestor could not extract an id. */
  providerEventId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<WebhookQueueStatusOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * Durable webhook inbox. One row per incoming HTTP request.
 * The background processing job picks up Pending rows and delegates to the provider-specific handler.
 * Provider-agnostic: works for Adyen, Stripe, Fiskaly, SendGrid, or any future integration.
 */
export type WebhookQueueSortInput = {
  attempts?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  /** Most recent error message from a failed processing attempt. Cleared on eventual success. */
  errorMessage?: InputMaybe<SortEnumType>;
  /** Request headers as JSON. Stored for background signature verification. */
  headers?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** Full raw request body. Kept for processing, replay, and diagnostics. */
  payload?: InputMaybe<SortEnumType>;
  processedAt?: InputMaybe<SortEnumType>;
  /** Provider name (e.g. "adyen", "stripe", "fiskaly"). Lower-cased by convention. */
  provider?: InputMaybe<SortEnumType>;
  /** Dedup key with Provider. Null when the ingestor could not extract an id. */
  providerEventId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** Processing outcome for a provider webhook event. */
export type WebhookQueueStatus = 'FAILED' | 'PENDING' | 'PROCESSED' | 'PROCESSING' | 'SKIPPED';

export type WebhookQueueStatusOperationFilterInput = {
  eq?: InputMaybe<WebhookQueueStatus>;
  in?: InputMaybe<Array<WebhookQueueStatus>>;
  neq?: InputMaybe<WebhookQueueStatus>;
  nin?: InputMaybe<Array<WebhookQueueStatus>>;
};

/** A connection to a list of items. */
export type WebhookQueuesConnection = {
  __typename: 'WebhookQueuesConnection';
  /** A list of edges. */
  edges: Maybe<Array<WebhookQueuesEdge>>;
  /** A flattened list of the nodes. */
  nodes: Maybe<Array<WebhookQueue>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WebhookQueuesEdge = {
  __typename: 'WebhookQueuesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: WebhookQueue;
};

export type GetOrganizationUnitsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  where?: InputMaybe<OrganizationUnitFilterInput>;
}>;

export type GetOrganizationUnitsQuery = {
  __typename: 'Query';
  organizationUnits: {
    __typename: 'OrganizationUnitsConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'OrganizationUnit';
      id: string;
      name: string;
      description: string | null;
      sort: number;
      branchType: string | null;
      appType: string | null;
      createdAt: string;
      updatedAt: string;
      organization: { __typename: 'Organization'; id: string; name: string };
      tenant: { __typename: 'Tenant'; id: string; name: string };
    }> | null;
    pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; endCursor: string | null };
  } | null;
};

export type GetOrganizationUnitQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetOrganizationUnitQuery = {
  __typename: 'Query';
  organizationUnit: {
    __typename: 'OrganizationUnit';
    id: string;
    name: string;
    description: string | null;
    sort: number;
    branchType: string | null;
    appType: string | null;
    additionalPropertiesJson: string | null;
    databaseId: string | null;
    createdAt: string;
    updatedAt: string;
    organizationId: string;
    tenantId: string;
    organization: { __typename: 'Organization'; id: string; name: string };
    tenant: { __typename: 'Tenant'; id: string; name: string };
  } | null;
};

export type GetOrganizationsForAddressListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type GetOrganizationsForAddressListQuery = {
  __typename: 'Query';
  organizations: {
    __typename: 'OrganizationsConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'Organization';
      id: string;
      name: string;
      isDefault: boolean;
      addresses: Array<{
        __typename: 'OrganizationAddress';
        id: string;
        type: AddressType;
        isDefault: boolean;
        addressLine1: string | null;
        addressLine2: string | null;
        city: string | null;
        zipCode: string | null;
        country: string | null;
        phoneNumber: string | null;
        email: string | null;
        description: string | null;
        latitude: number | null;
        longitude: number | null;
        status: string | null;
        createdAt: string;
        updatedAt: string;
        organization: { __typename: 'Organization'; id: string; name: string };
        tenant: { __typename: 'Tenant'; id: string; name: string };
        organizationUnit: { __typename: 'OrganizationUnit'; id: string; name: string } | null;
      }>;
    }> | null;
    pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; endCursor: string | null };
  } | null;
};

export type GetOrganizationAddressesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OrganizationAddressFilterInput>;
}>;

export type GetOrganizationAddressesQuery = {
  __typename: 'Query';
  organizationAddresses: {
    __typename: 'OrganizationAddressesConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'OrganizationAddress';
      id: string;
      type: AddressType;
      isDefault: boolean;
      addressLine1: string | null;
      addressLine2: string | null;
      city: string | null;
      zipCode: string | null;
      country: string | null;
      phoneNumber: string | null;
      email: string | null;
      description: string | null;
      latitude: number | null;
      longitude: number | null;
      status: string | null;
      createdAt: string;
      updatedAt: string;
      organization: { __typename: 'Organization'; id: string; name: string };
      tenant: { __typename: 'Tenant'; id: string; name: string };
      organizationUnit: { __typename: 'OrganizationUnit'; id: string; name: string } | null;
    }> | null;
    pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; endCursor: string | null };
  } | null;
};

export type GetOrganizationAddressQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetOrganizationAddressQuery = {
  __typename: 'Query';
  organizationAddress: {
    __typename: 'OrganizationAddress';
    id: string;
    type: AddressType;
    isDefault: boolean;
    addressLine1: string | null;
    addressLine2: string | null;
    city: string | null;
    zipCode: string | null;
    country: string | null;
    phoneNumber: string | null;
    email: string | null;
    description: string | null;
    latitude: number | null;
    longitude: number | null;
    status: string | null;
    organizationId: string;
    organizationUnitId: string | null;
    tenantId: string;
    createdAt: string;
    updatedAt: string;
    organization: { __typename: 'Organization'; id: string; name: string };
    organizationUnit: { __typename: 'OrganizationUnit'; id: string; name: string } | null;
    tenant: { __typename: 'Tenant'; id: string; name: string };
  } | null;
};

export type GetOrganizationContactsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OrganizationContactFilterInput>;
}>;

export type GetOrganizationContactsQuery = {
  __typename: 'Query';
  organizationContacts: {
    __typename: 'OrganizationContactsConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'OrganizationContact';
      id: string;
      firstName: string | null;
      lastName: string | null;
      email: string | null;
      position: string | null;
      salutation: string | null;
      createdAt: string;
      updatedAt: string;
      organization: { __typename: 'Organization'; id: string; name: string };
      tenant: { __typename: 'Tenant'; id: string; name: string };
    }> | null;
    pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; endCursor: string | null };
  } | null;
};

export type GetOrganizationContactQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetOrganizationContactQuery = {
  __typename: 'Query';
  organizationContact: {
    __typename: 'OrganizationContact';
    id: string;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    position: string | null;
    salutation: string | null;
    organizationId: string;
    tenantId: string;
    createdAt: string;
    updatedAt: string;
    organization: { __typename: 'Organization'; id: string; name: string };
    tenant: { __typename: 'Tenant'; id: string; name: string };
  } | null;
};

export type GetPaymentGatewaysListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PaymentGatewayFilterInput>;
}>;

export type GetPaymentGatewaysListQuery = {
  __typename: 'Query';
  paymentGateways: {
    __typename: 'PaymentGatewaysConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'PaymentGateway';
      id: string;
      name: string;
      provider: string;
      isActive: boolean;
      isDefault: boolean;
      createdAt: string;
      updatedAt: string;
    }> | null;
    pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; endCursor: string | null };
  } | null;
};

export type GetPaymentGatewayQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetPaymentGatewayQuery = {
  __typename: 'Query';
  paymentGateway: {
    __typename: 'PaymentGateway';
    id: string;
    name: string;
    provider: string;
    isActive: boolean;
    isDefault: boolean;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GetPaymentTermsListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PaymentTermFilterInput>;
}>;

export type GetPaymentTermsListQuery = {
  __typename: 'Query';
  paymentTerms: {
    __typename: 'PaymentTermsConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'PaymentTerm';
      id: string;
      name: string;
      days: number;
      isActive: boolean;
      isDefault: boolean;
      createdAt: string;
      updatedAt: string;
    }> | null;
    pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; endCursor: string | null };
  } | null;
};

export type GetPaymentTermQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetPaymentTermQuery = {
  __typename: 'Query';
  paymentTerm: {
    __typename: 'PaymentTerm';
    id: string;
    name: string;
    days: number;
    isActive: boolean;
    isDefault: boolean;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GetPlansListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PlanFilterInput>;
}>;

export type GetPlansListQuery = {
  __typename: 'Query';
  plans: {
    __typename: 'PlansConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'Plan';
      id: string;
      name: string;
      code: string;
      contractTermMonths: number;
      amountNet: number;
      amountGross: number;
      createdAt: string;
      updatedAt: string;
    }> | null;
    pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; endCursor: string | null };
  } | null;
};

export type GetPlanDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetPlanDetailQuery = {
  __typename: 'Query';
  plan: {
    __typename: 'Plan';
    id: string;
    name: string;
    code: string;
    contractTermMonths: number;
    amountNet: number;
    amountGross: number;
    createdAt: string;
    updatedAt: string;
    skus: Array<string>;
  } | null;
};

export type GetProductsListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProductFilterInput>;
}>;

export type GetProductsListQuery = {
  __typename: 'Query';
  products: {
    __typename: 'ProductsConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'Product';
      id: string;
      name: string;
      number: string;
      type: ProductType;
      sku: string;
      shortDescription: string | null;
      sort: number;
      createdAt: string;
      updatedAt: string;
    }> | null;
    pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; endCursor: string | null };
  } | null;
};

export type GetProductDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetProductDetailQuery = {
  __typename: 'Query';
  product: {
    __typename: 'Product';
    id: string;
    name: string;
    number: string;
    type: ProductType;
    sku: string;
    shortDescription: string | null;
    longDescription: string | null;
    sort: number;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GetTaxRulesListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<TaxRuleFilterInput>;
}>;

export type GetTaxRulesListQuery = {
  __typename: 'Query';
  taxRules: {
    __typename: 'TaxRulesConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'TaxRule';
      id: string;
      name: string;
      taxRate: number;
      isActive: boolean;
      isDefault: boolean;
      printText: string | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; endCursor: string | null };
  } | null;
};

export type GetTaxRuleQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetTaxRuleQuery = {
  __typename: 'Query';
  taxRule: {
    __typename: 'TaxRule';
    id: string;
    name: string;
    taxRate: number;
    isActive: boolean;
    isDefault: boolean;
    printText: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateOrganizationUnitMutationVariables = Exact<{
  input: CreateOrganizationUnitInput;
}>;

export type CreateOrganizationUnitMutation = {
  __typename: 'Mutation';
  createOrganizationUnit: {
    __typename: 'CreateOrganizationUnitPayload';
    organizationUnit: {
      __typename: 'OrganizationUnit';
      id: string;
      name: string;
      description: string | null;
      sort: number;
      branchType: string | null;
      appType: string | null;
      additionalPropertiesJson: string | null;
      databaseId: string | null;
      organizationId: string;
      tenantId: string;
      createdAt: string;
      updatedAt: string;
      organization: { __typename: 'Organization'; id: string; name: string };
      tenant: { __typename: 'Tenant'; id: string; name: string };
    } | null;
  };
};

export type UpdateOrganizationUnitMutationVariables = Exact<{
  input: UpdateOrganizationUnitInput;
}>;

export type UpdateOrganizationUnitMutation = {
  __typename: 'Mutation';
  updateOrganizationUnit: {
    __typename: 'UpdateOrganizationUnitPayload';
    organizationUnit: {
      __typename: 'OrganizationUnit';
      id: string;
      name: string;
      description: string | null;
      sort: number;
      branchType: string | null;
      appType: string | null;
      additionalPropertiesJson: string | null;
      databaseId: string | null;
      organizationId: string;
      tenantId: string;
      createdAt: string;
      updatedAt: string;
    } | null;
  };
};

export type DeleteOrganizationUnitMutationVariables = Exact<{
  input: DeleteOrganizationUnitInput;
}>;

export type DeleteOrganizationUnitMutation = {
  __typename: 'Mutation';
  deleteOrganizationUnit: { __typename: 'DeleteOrganizationUnitPayload'; boolean: boolean | null };
};

export type CreateOrganizationAddressMutationVariables = Exact<{
  input: CreateOrganizationAddressInput;
}>;

export type CreateOrganizationAddressMutation = {
  __typename: 'Mutation';
  createOrganizationAddress: {
    __typename: 'CreateOrganizationAddressPayload';
    organizationAddress: {
      __typename: 'OrganizationAddress';
      id: string;
      type: AddressType;
      isDefault: boolean;
      addressLine1: string | null;
      addressLine2: string | null;
      city: string | null;
      zipCode: string | null;
      country: string | null;
      phoneNumber: string | null;
      email: string | null;
      description: string | null;
      latitude: number | null;
      longitude: number | null;
      status: string | null;
      organizationId: string;
      organizationUnitId: string | null;
      tenantId: string;
      createdAt: string;
      updatedAt: string;
    } | null;
  };
};

export type UpdateOrganizationAddressMutationVariables = Exact<{
  input: UpdateOrganizationAddressInput;
}>;

export type UpdateOrganizationAddressMutation = {
  __typename: 'Mutation';
  updateOrganizationAddress: {
    __typename: 'UpdateOrganizationAddressPayload';
    organizationAddress: {
      __typename: 'OrganizationAddress';
      id: string;
      type: AddressType;
      isDefault: boolean;
      addressLine1: string | null;
      addressLine2: string | null;
      city: string | null;
      zipCode: string | null;
      country: string | null;
      phoneNumber: string | null;
      email: string | null;
      description: string | null;
      latitude: number | null;
      longitude: number | null;
      status: string | null;
      organizationId: string;
      organizationUnitId: string | null;
      tenantId: string;
      createdAt: string;
      updatedAt: string;
    } | null;
  };
};

export type DeleteOrganizationAddressMutationVariables = Exact<{
  input: DeleteOrganizationAddressInput;
}>;

export type DeleteOrganizationAddressMutation = {
  __typename: 'Mutation';
  deleteOrganizationAddress: {
    __typename: 'DeleteOrganizationAddressPayload';
    boolean: boolean | null;
  };
};

export type CreateOrganizationContactMutationVariables = Exact<{
  input: CreateOrganizationContactInput;
}>;

export type CreateOrganizationContactMutation = {
  __typename: 'Mutation';
  createOrganizationContact: {
    __typename: 'CreateOrganizationContactPayload';
    organizationContact: {
      __typename: 'OrganizationContact';
      id: string;
      firstName: string | null;
      lastName: string | null;
      email: string | null;
      position: string | null;
      salutation: string | null;
      organizationId: string;
      tenantId: string;
      createdAt: string;
      updatedAt: string;
    } | null;
  };
};

export type UpdateOrganizationContactMutationVariables = Exact<{
  input: UpdateOrganizationContactInput;
}>;

export type UpdateOrganizationContactMutation = {
  __typename: 'Mutation';
  updateOrganizationContact: {
    __typename: 'UpdateOrganizationContactPayload';
    organizationContact: {
      __typename: 'OrganizationContact';
      id: string;
      firstName: string | null;
      lastName: string | null;
      email: string | null;
      position: string | null;
      salutation: string | null;
      organizationId: string;
      tenantId: string;
      createdAt: string;
      updatedAt: string;
    } | null;
  };
};

export type DeleteOrganizationContactMutationVariables = Exact<{
  input: DeleteOrganizationContactInput;
}>;

export type DeleteOrganizationContactMutation = {
  __typename: 'Mutation';
  deleteOrganizationContact: {
    __typename: 'DeleteOrganizationContactPayload';
    boolean: boolean | null;
  };
};

export type CreatePaymentGatewayMutationVariables = Exact<{
  input: CreatePaymentGatewayInput;
}>;

export type CreatePaymentGatewayMutation = {
  __typename: 'Mutation';
  createPaymentGateway: {
    __typename: 'CreatePaymentGatewayPayload';
    paymentGateway: {
      __typename: 'PaymentGateway';
      id: string;
      name: string;
      provider: string;
      isActive: boolean;
      isDefault: boolean;
      createdAt: string;
      updatedAt: string;
    } | null;
  };
};

export type UpdatePaymentGatewayMutationVariables = Exact<{
  input: UpdatePaymentGatewayInput;
}>;

export type UpdatePaymentGatewayMutation = {
  __typename: 'Mutation';
  updatePaymentGateway: {
    __typename: 'UpdatePaymentGatewayPayload';
    paymentGateway: {
      __typename: 'PaymentGateway';
      id: string;
      name: string;
      provider: string;
      isActive: boolean;
      isDefault: boolean;
      createdAt: string;
      updatedAt: string;
    } | null;
  };
};

export type DeletePaymentGatewayMutationVariables = Exact<{
  input: DeletePaymentGatewayInput;
}>;

export type DeletePaymentGatewayMutation = {
  __typename: 'Mutation';
  deletePaymentGateway: { __typename: 'DeletePaymentGatewayPayload'; boolean: boolean | null };
};

export type CreatePaymentTermMutationVariables = Exact<{
  input: CreatePaymentTermInput;
}>;

export type CreatePaymentTermMutation = {
  __typename: 'Mutation';
  createPaymentTerm: {
    __typename: 'CreatePaymentTermPayload';
    paymentTerm: {
      __typename: 'PaymentTerm';
      id: string;
      name: string;
      days: number;
      isActive: boolean;
      isDefault: boolean;
      createdAt: string;
      updatedAt: string;
    } | null;
  };
};

export type UpdatePaymentTermMutationVariables = Exact<{
  input: UpdatePaymentTermInput;
}>;

export type UpdatePaymentTermMutation = {
  __typename: 'Mutation';
  updatePaymentTerm: {
    __typename: 'UpdatePaymentTermPayload';
    paymentTerm: {
      __typename: 'PaymentTerm';
      id: string;
      name: string;
      days: number;
      isActive: boolean;
      isDefault: boolean;
      createdAt: string;
      updatedAt: string;
    } | null;
  };
};

export type DeletePaymentTermMutationVariables = Exact<{
  input: DeletePaymentTermInput;
}>;

export type DeletePaymentTermMutation = {
  __typename: 'Mutation';
  deletePaymentTerm: { __typename: 'DeletePaymentTermPayload'; boolean: boolean | null };
};

export type CreatePlanMutationVariables = Exact<{
  input: CreatePlanInput;
}>;

export type CreatePlanMutation = {
  __typename: 'Mutation';
  createPlan: {
    __typename: 'CreatePlanPayload';
    plan: {
      __typename: 'Plan';
      id: string;
      name: string;
      code: string;
      contractTermMonths: number;
      amountNet: number;
      amountGross: number;
      createdAt: string;
      updatedAt: string;
    } | null;
  };
};

export type UpdatePlanMutationVariables = Exact<{
  input: UpdatePlanInput;
}>;

export type UpdatePlanMutation = {
  __typename: 'Mutation';
  updatePlan: {
    __typename: 'UpdatePlanPayload';
    plan: {
      __typename: 'Plan';
      id: string;
      name: string;
      code: string;
      amountNet: number;
      amountGross: number;
      contractTermMonths: number;
      createdAt: string;
      updatedAt: string;
    } | null;
  };
};

export type CreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;

export type CreateProductMutation = {
  __typename: 'Mutation';
  createProduct: {
    __typename: 'CreateProductPayload';
    product: {
      __typename: 'Product';
      id: string;
      name: string;
      number: string;
      type: ProductType;
      sku: string;
      sort: number;
      shortDescription: string | null;
      longDescription: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
  };
};

export type UpdateProductMutationVariables = Exact<{
  input: UpdateProductInput;
}>;

export type UpdateProductMutation = {
  __typename: 'Mutation';
  updateProduct: {
    __typename: 'UpdateProductPayload';
    product: {
      __typename: 'Product';
      id: string;
      name: string;
      number: string;
      type: ProductType;
      sku: string;
      sort: number;
      shortDescription: string | null;
      longDescription: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
  };
};

export type CreateTaxRuleMutationVariables = Exact<{
  input: CreateTaxRuleInput;
}>;

export type CreateTaxRuleMutation = {
  __typename: 'Mutation';
  createTaxRule: {
    __typename: 'CreateTaxRulePayload';
    taxRule: {
      __typename: 'TaxRule';
      id: string;
      name: string;
      taxRate: number;
      isActive: boolean;
      isDefault: boolean;
      printText: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
  };
};

export type UpdateTaxRuleMutationVariables = Exact<{
  input: UpdateTaxRuleInput;
}>;

export type UpdateTaxRuleMutation = {
  __typename: 'Mutation';
  updateTaxRule: {
    __typename: 'UpdateTaxRulePayload';
    taxRule: {
      __typename: 'TaxRule';
      id: string;
      name: string;
      taxRate: number;
      isActive: boolean;
      isDefault: boolean;
      printText: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
  };
};

export type DeleteTaxRuleMutationVariables = Exact<{
  input: DeleteTaxRuleInput;
}>;

export type DeleteTaxRuleMutation = {
  __typename: 'Mutation';
  deleteTaxRule: { __typename: 'DeleteTaxRulePayload'; boolean: boolean | null };
};

export type GetAppVersionsListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<AppVersionFilterInput>;
}>;

export type GetAppVersionsListQuery = {
  __typename: 'Query';
  appVersions: {
    __typename: 'AppVersionsConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'AppVersion';
      id: string;
      versionName: string;
      versionCode: number;
      releaseNotes: string;
      releaseDate: string;
      isActive: boolean;
      createdAt: string;
      updatedAt: string;
    }> | null;
    pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; endCursor: string | null };
  } | null;
};

export type GetAppVersionDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetAppVersionDetailQuery = {
  __typename: 'Query';
  appVersion: {
    __typename: 'AppVersion';
    id: string;
    versionName: string;
    versionCode: number;
    releaseNotes: string;
    releaseDate: string;
    isActive: boolean;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GetAppVersionPolicyQueryVariables = Exact<{ [key: string]: never }>;

export type GetAppVersionPolicyQuery = {
  __typename: 'Query';
  appVersionPolicy: {
    __typename: 'AppVersionPolicy';
    requiredMinVersion: string | null;
    suggestedMinVersion: string | null;
    updateStoreUrl: string | null;
  };
};

export type CreateAppVersionMutationVariables = Exact<{
  input: CreateAppVersionInput;
}>;

export type CreateAppVersionMutation = {
  __typename: 'Mutation';
  createAppVersion: {
    __typename: 'CreateAppVersionPayload';
    appVersion: {
      __typename: 'AppVersion';
      id: string;
      versionName: string;
      versionCode: number;
      releaseNotes: string;
      releaseDate: string;
      isActive: boolean;
      createdAt: string;
      updatedAt: string;
    } | null;
  };
};

export type UpdateAppVersionMutationVariables = Exact<{
  input: UpdateAppVersionInput;
}>;

export type UpdateAppVersionMutation = {
  __typename: 'Mutation';
  updateAppVersion: {
    __typename: 'UpdateAppVersionPayload';
    appVersion: {
      __typename: 'AppVersion';
      id: string;
      versionName: string;
      versionCode: number;
      releaseNotes: string;
      releaseDate: string;
      isActive: boolean;
      createdAt: string;
      updatedAt: string;
    } | null;
  };
};

export type DeleteAppVersionMutationVariables = Exact<{
  input: DeleteAppVersionInput;
}>;

export type DeleteAppVersionMutation = {
  __typename: 'Mutation';
  deleteAppVersion: { __typename: 'DeleteAppVersionPayload'; boolean: boolean | null };
};

export type UpdateAppVersionPolicyMutationVariables = Exact<{
  input: UpdateAppVersionPolicyInput;
}>;

export type UpdateAppVersionPolicyMutation = {
  __typename: 'Mutation';
  updateAppVersionPolicy: {
    __typename: 'UpdateAppVersionPolicyPayload';
    appVersionPolicy: {
      __typename: 'AppVersionPolicy';
      requiredMinVersion: string | null;
      suggestedMinVersion: string | null;
      updateStoreUrl: string | null;
    } | null;
  };
};

export type UpdateTenantDiscountPercentMutationVariables = Exact<{
  input: UpdateTenantDiscountPercentInput;
}>;

export type UpdateTenantDiscountPercentMutation = {
  __typename: 'Mutation';
  updateTenantDiscountPercent: {
    __typename: 'UpdateTenantDiscountPercentPayload';
    tenant: { __typename: 'Tenant'; id: string; discountPercent: number | null } | null;
  };
};

export type UpdateTenantResellerLogoMutationVariables = Exact<{
  input: UpdateTenantResellerLogoInput;
}>;

export type UpdateTenantResellerLogoMutation = {
  __typename: 'Mutation';
  updateTenantResellerLogo: {
    __typename: 'UpdateTenantResellerLogoPayload';
    tenant: { __typename: 'Tenant'; id: string; resellerLogo: string | null } | null;
    errors: Array<
      | { __typename: 'EntityNotFoundError'; message: string }
      | { __typename: 'InvalidOperationError'; message: string }
    > | null;
  };
};

export type CreateProvisionPayoutMutationVariables = Exact<{
  input: CreateProvisionPayoutInput;
}>;

export type CreateProvisionPayoutMutation = {
  __typename: 'Mutation';
  createProvisionPayout: {
    __typename: 'CreateProvisionPayoutPayload';
    accountingDocument: {
      __typename: 'AccountingDocument';
      id: string;
      number: string;
      amountNet: number;
      amountGross: number;
      state: AccountingDocumentState;
      createdAt: string;
    } | null;
  };
};

export type GetCouponsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<CouponFilterInput>;
}>;

export type GetCouponsQuery = {
  __typename: 'Query';
  coupons: {
    __typename: 'CouponsConnection';
    nodes: Array<{
      __typename: 'Coupon';
      id: string;
      code: string;
      name: string;
      description: string | null;
      type: CouponType;
      duration: number | null;
      discountType: CouponDiscountType;
      discountValue: number;
      status: CouponStatus;
      usageType: CouponUsageType;
      maxRedemptions: number | null;
      redemptionCount: number;
      expiryDate: string | null;
      allowedPlanCodes: Array<string>;
      allowedProductSkus: Array<string>;
      createdAt: string;
      updatedAt: string;
    }> | null;
  } | null;
};

export type GetAvailableCouponsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<CouponFilterInput>;
  order?: InputMaybe<Array<CouponSortInput> | CouponSortInput>;
}>;

export type GetAvailableCouponsQuery = {
  __typename: 'Query';
  availableCoupons: {
    __typename: 'AvailableCouponsConnection';
    nodes: Array<{
      __typename: 'Coupon';
      id: string;
      code: string;
      name: string;
      description: string | null;
      type: CouponType;
      duration: number | null;
      discountType: CouponDiscountType;
      discountValue: number;
      status: CouponStatus;
      maxRedemptions: number | null;
      redemptionCount: number;
      expiryDate: string | null;
      allowedPlanCodes: Array<string>;
      allowedProductSkus: Array<string>;
      createdAt: string;
      updatedAt: string;
    }> | null;
  } | null;
};

export type GetCouponQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetCouponQuery = {
  __typename: 'Query';
  coupon: {
    __typename: 'Coupon';
    id: string;
    code: string;
    name: string;
    description: string | null;
    type: CouponType;
    duration: number | null;
    discountType: CouponDiscountType;
    discountValue: number;
    status: CouponStatus;
    usageType: CouponUsageType;
    maxRedemptions: number | null;
    redemptionCount: number;
    expiryDate: string | null;
    allowedPlanCodes: Array<string>;
    allowedProductSkus: Array<string>;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateCouponMutationVariables = Exact<{
  input: CreateCouponInput;
}>;

export type CreateCouponMutation = {
  __typename: 'Mutation';
  createCoupon: {
    __typename: 'CreateCouponPayload';
    coupon: { __typename: 'Coupon'; id: string } | null;
  };
};

export type UpdateCouponMutationVariables = Exact<{
  input: UpdateCouponInput;
}>;

export type UpdateCouponMutation = {
  __typename: 'Mutation';
  updateCoupon: {
    __typename: 'UpdateCouponPayload';
    coupon: { __typename: 'Coupon'; id: string } | null;
  };
};

export type DeleteCouponMutationVariables = Exact<{
  input: DeleteCouponInput;
}>;

export type DeleteCouponMutation = {
  __typename: 'Mutation';
  deleteCoupon: { __typename: 'DeleteCouponPayload'; boolean: boolean | null };
};

export type MainCouponQueryVariables = Exact<{ [key: string]: never }>;

export type MainCouponQuery = {
  __typename: 'Query';
  mainCoupon: {
    __typename: 'MainCouponPromo';
    id: string;
    code: string;
    discountPercent: number;
  } | null;
};

export type UpdateMainCouponMutationVariables = Exact<{
  input: UpdateMainCouponInput;
}>;

export type UpdateMainCouponMutation = {
  __typename: 'Mutation';
  updateMainCoupon: { __typename: 'UpdateMainCouponPayload'; boolean: boolean | null };
};

export type DeleteMainCouponMutationVariables = Exact<{ [key: string]: never }>;

export type DeleteMainCouponMutation = {
  __typename: 'Mutation';
  deleteMainCoupon: { __typename: 'DeleteMainCouponPayload'; boolean: boolean | null };
};

export type ResourceFieldsFragment = {
  __typename: 'Resource';
  id: string;
  title: string;
  fileName: string;
  contentType: string;
  previewBase64: string | null;
  fileSizeBytes: number;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
};

export type GetResourcesQueryVariables = Exact<{ [key: string]: never }>;

export type GetResourcesQuery = {
  __typename: 'Query';
  resources: Array<{
    __typename: 'Resource';
    id: string;
    title: string;
    fileName: string;
    contentType: string;
    previewBase64: string | null;
    fileSizeBytes: number;
    sortOrder: number;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetResourceQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetResourceQuery = {
  __typename: 'Query';
  resource: {
    __typename: 'Resource';
    id: string;
    title: string;
    fileName: string;
    contentType: string;
    contentBase64: string | null;
    previewBase64: string | null;
    fileSizeBytes: number;
    sortOrder: number;
  } | null;
};

export type CreateResourceMutationVariables = Exact<{
  input: CreateResourceInput;
}>;

export type CreateResourceMutation = {
  __typename: 'Mutation';
  createResource: {
    __typename: 'CreateResourcePayload';
    resource: {
      __typename: 'Resource';
      id: string;
      title: string;
      fileName: string;
      contentType: string;
      previewBase64: string | null;
      fileSizeBytes: number;
      sortOrder: number;
      createdAt: string;
      updatedAt: string;
    } | null;
    errors: Array<{ __typename: 'InvalidOperationError'; message: string }> | null;
  };
};

export type UpdateResourceMutationVariables = Exact<{
  input: UpdateResourceInput;
}>;

export type UpdateResourceMutation = {
  __typename: 'Mutation';
  updateResource: {
    __typename: 'UpdateResourcePayload';
    resource: {
      __typename: 'Resource';
      id: string;
      title: string;
      fileName: string;
      contentType: string;
      previewBase64: string | null;
      fileSizeBytes: number;
      sortOrder: number;
      createdAt: string;
      updatedAt: string;
    } | null;
    errors: Array<
      | { __typename: 'EntityNotFoundError'; message: string }
      | { __typename: 'InvalidOperationError'; message: string }
    > | null;
  };
};

export type DeleteResourceMutationVariables = Exact<{
  input: DeleteResourceInput;
}>;

export type DeleteResourceMutation = {
  __typename: 'Mutation';
  deleteResource: {
    __typename: 'DeleteResourcePayload';
    boolean: boolean | null;
    errors: Array<{ __typename: 'EntityNotFoundError'; message: string }> | null;
  };
};

export type ReorderResourcesMutationVariables = Exact<{
  input: ReorderResourcesInput;
}>;

export type ReorderResourcesMutation = {
  __typename: 'Mutation';
  reorderResources: {
    __typename: 'ReorderResourcesPayload';
    resource: Array<{
      __typename: 'Resource';
      id: string;
      title: string;
      fileName: string;
      contentType: string;
      previewBase64: string | null;
      fileSizeBytes: number;
      sortOrder: number;
      createdAt: string;
      updatedAt: string;
    }> | null;
    errors: Array<{ __typename: 'EntityNotFoundError'; message: string }> | null;
  };
};

export type InvitationFieldsFragment = {
  __typename: 'Invitation';
  id: string;
  tenantId: string;
  token: string;
  state: InvitationState;
  recipientTenantId: string | null;
  recipientEmail: string;
  recipientName: string | null;
  message: string | null;
  createdAt: string;
  updatedAt: string | null;
  respondedAt: string | null;
};

export type GetInvitationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<InvitationFilterInput>;
}>;

export type GetInvitationsQuery = {
  __typename: 'Query';
  invitations: {
    __typename: 'InvitationsConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'Invitation';
      id: string;
      tenantId: string;
      token: string;
      state: InvitationState;
      recipientTenantId: string | null;
      recipientEmail: string;
      recipientName: string | null;
      message: string | null;
      createdAt: string;
      updatedAt: string | null;
      respondedAt: string | null;
    }> | null;
    pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; endCursor: string | null };
  } | null;
};

export type CreateInvitationMutationVariables = Exact<{
  input: CreateInvitationInput;
}>;

export type CreateInvitationMutation = {
  __typename: 'Mutation';
  createInvitation: {
    __typename: 'CreateInvitationPayload';
    invitation: {
      __typename: 'Invitation';
      id: string;
      tenantId: string;
      token: string;
      state: InvitationState;
      recipientTenantId: string | null;
      recipientEmail: string;
      recipientName: string | null;
      message: string | null;
      createdAt: string;
      updatedAt: string | null;
      respondedAt: string | null;
    } | null;
  };
};

export type ResendInvitationMutationVariables = Exact<{
  input: ResendInvitationInput;
}>;

export type ResendInvitationMutation = {
  __typename: 'Mutation';
  resendInvitation: {
    __typename: 'ResendInvitationPayload';
    invitation: {
      __typename: 'Invitation';
      id: string;
      tenantId: string;
      token: string;
      state: InvitationState;
      recipientTenantId: string | null;
      recipientEmail: string;
      recipientName: string | null;
      message: string | null;
      createdAt: string;
      updatedAt: string | null;
      respondedAt: string | null;
    } | null;
  };
};

export type MarkInvitationFailedMutationVariables = Exact<{
  input: MarkInvitationFailedInput;
}>;

export type MarkInvitationFailedMutation = {
  __typename: 'Mutation';
  markInvitationFailed: {
    __typename: 'MarkInvitationFailedPayload';
    invitation: {
      __typename: 'Invitation';
      id: string;
      tenantId: string;
      token: string;
      state: InvitationState;
      recipientTenantId: string | null;
      recipientEmail: string;
      recipientName: string | null;
      message: string | null;
      createdAt: string;
      updatedAt: string | null;
      respondedAt: string | null;
    } | null;
  };
};

export type RevokeInvitationMutationVariables = Exact<{
  input: RevokeInvitationInput;
}>;

export type RevokeInvitationMutation = {
  __typename: 'Mutation';
  revokeInvitation: { __typename: 'RevokeInvitationPayload'; boolean: boolean | null };
};

export type UpdateLicenceStateMutationVariables = Exact<{
  input: UpdateLicenceStateInput;
}>;

export type UpdateLicenceStateMutation = {
  __typename: 'Mutation';
  updateLicenceState: {
    __typename: 'UpdateLicenceStatePayload';
    licence: { __typename: 'Licence'; id: string; state: LicenceState; updatedAt: string } | null;
    errors: Array<{ __typename: 'EntityNotFoundError'; message: string }> | null;
  };
};

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;

export type CreateOrganizationMutation = {
  __typename: 'Mutation';
  createOrganization: {
    __typename: 'CreateOrganizationPayload';
    organization: {
      __typename: 'Organization';
      id: string;
      name: string;
      description: string | null;
      status: OrganizationStatus;
      isDefault: boolean;
      type: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
  };
};

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;

export type UpdateOrganizationMutation = {
  __typename: 'Mutation';
  updateOrganization: {
    __typename: 'UpdateOrganizationPayload';
    organization: {
      __typename: 'Organization';
      id: string;
      name: string;
      description: string | null;
      status: OrganizationStatus;
      isDefault: boolean;
      type: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    errors: Array<{ __typename: 'EntityNotFoundError'; message: string }> | null;
  };
};

export type GetUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserQuery = {
  __typename: 'Query';
  user: {
    __typename: 'UserInfoResult';
    sub: string;
    email: string | null;
    givenName: string | null;
    familyName: string | null;
    role: Array<string> | null;
    resellerId: string | null;
  };
};

export type GetTenantsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  resellerId?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TenantFilterInput>;
}>;

export type GetTenantsQuery = {
  __typename: 'Query';
  tenants: {
    __typename: 'TenantsConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'Tenant';
      id: string;
      tenantNumber: number;
      name: string;
      type: TenantType;
      status: TenantStatus;
      resellerId: number | null;
      parentId: string | null;
      discountPercent: number | null;
      createdAt: string;
    }> | null;
    pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; endCursor: string | null };
  } | null;
};

export type GetTenantQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetTenantQuery = {
  __typename: 'Query';
  tenant: {
    __typename: 'Tenant';
    id: string;
    tenantNumber: number;
    name: string;
    type: TenantType;
    status: TenantStatus;
    resellerId: number | null;
    parentId: string | null;
    discountPercent: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GetSubscriptionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  where?: InputMaybe<SubscriptionFilterInput>;
}>;

export type GetSubscriptionsQuery = {
  __typename: 'Query';
  subscriptions: {
    __typename: 'SubscriptionsConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'Subscription';
      id: string;
      tenantId: string;
      number: string;
      state: SubscriptionState;
      intervalMonths: number;
      amountNet: number | null;
      amountGross: number | null;
      currencyCode: string | null;
      activationDate: string | null;
      cancellationDate: string | null;
      expiryDate: string | null;
      currentTermStartDate: string | null;
      currentTermEndDate: string | null;
      createdAt: string;
      plan: { __typename: 'Plan'; id: string; name: string };
      tenant: { __typename: 'Tenant'; id: string; name: string };
      organizationUnit: { __typename: 'OrganizationUnit'; id: string; name: string };
      subscriptionItems: Array<{
        __typename: 'SubscriptionItem';
        id: string;
        quantity: number;
        unitPriceNet: number;
        unitPriceGross: number;
      }>;
    }> | null;
    pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; endCursor: string | null };
  } | null;
};

export type GetAccountingDocumentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  resellerTenantId?: InputMaybe<Scalars['UUID']['input']>;
  where?: InputMaybe<AccountingDocumentFilterInput>;
}>;

export type GetAccountingDocumentsQuery = {
  __typename: 'Query';
  accountingDocuments: {
    __typename: 'AccountingDocumentsConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'AccountingDocument';
      id: string;
      tenantId: string;
      type: AccountingDocumentType;
      number: string;
      state: AccountingDocumentState;
      currencyCode: string;
      amountNet: number;
      amountGross: number;
      taxAmount: number;
      additionalPropertiesJson: string | null;
      createdAt: string;
      sentAt: string | null;
      pdfDataBase64: string | null;
      tenant: { __typename: 'Tenant'; id: string; name: string };
      subscription: {
        __typename: 'Subscription';
        id: string;
        number: string;
        organizationUnit: {
          __typename: 'OrganizationUnit';
          organization: { __typename: 'Organization'; id: string; name: string };
        };
      } | null;
      items: Array<{
        __typename: 'AccountingDocumentItem';
        id: string;
        name: string;
        quantity: number;
        unitPriceNet: number;
        unitPriceGross: number;
        amountNet: number;
        amountGross: number;
      }>;
    }> | null;
    pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; endCursor: string | null };
  } | null;
};

export type GetPaymentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type GetPaymentsQuery = {
  __typename: 'Query';
  payments: {
    __typename: 'PaymentsConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'Payment';
      id: string;
      accountingDocumentId: string | null;
      state: PaymentState;
      direction: PaymentDirection;
      amountNet: number;
      amountGross: number;
      currencyCode: string | null;
      reference: string | null;
      paymentDate: string | null;
      createdAt: string;
      accountingDocument: {
        __typename: 'AccountingDocument';
        id: string;
        number: string;
        tenantId: string;
        tenant: { __typename: 'Tenant'; id: string; name: string };
        subscription: {
          __typename: 'Subscription';
          organizationUnit: {
            __typename: 'OrganizationUnit';
            organization: { __typename: 'Organization'; id: string; name: string };
          };
        } | null;
      } | null;
      paymentGateway: { __typename: 'PaymentGateway'; id: string; name: string } | null;
    }> | null;
    pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; endCursor: string | null };
  } | null;
};

export type GetLicencesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  where?: InputMaybe<LicenceFilterInput>;
}>;

export type GetLicencesQuery = {
  __typename: 'Query';
  licences: {
    __typename: 'LicencesConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'Licence';
      id: string;
      tenantId: string;
      organizationUnitId: string | null;
      databaseId: string | null;
      subscriptionItemId: string | null;
      serial: string;
      appName: string;
      appVersion: number;
      appType: AppType;
      appReglevel: number;
      state: LicenceState;
      type: LicenceType;
      registrationDate: string | null;
      expirationDate: string | null;
      deviceUid: string | null;
      deviceBrand: string | null;
      deviceModel: string | null;
      deviceOS: string | null;
      deviceInfo: string | null;
      deviceDetails: string | null;
      additionalPropertiesJson: string | null;
      createdAt: string;
      updatedAt: string;
      tenant: { __typename: 'Tenant'; id: string; name: string };
      organizationUnit: { __typename: 'OrganizationUnit'; id: string; name: string } | null;
      subscriptionItem: { __typename: 'SubscriptionItem'; id: string } | null;
    }> | null;
    pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; endCursor: string | null };
  } | null;
};

export type GetOrganizationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  where?: InputMaybe<OrganizationFilterInput>;
}>;

export type GetOrganizationsQuery = {
  __typename: 'Query';
  organizations: {
    __typename: 'OrganizationsConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'Organization';
      id: string;
      tenantId: string;
      name: string;
      description: string | null;
      status: OrganizationStatus;
      type: string | null;
      customerNumber: string;
      createdAt: string;
      updatedAt: string;
      tenant: { __typename: 'Tenant'; id: string; name: string; resellerId: number | null };
    }> | null;
    pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; endCursor: string | null };
  } | null;
};

export type GetDashboardOrganizationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  where?: InputMaybe<OrganizationFilterInput>;
}>;

export type GetDashboardOrganizationsQuery = {
  __typename: 'Query';
  organizations: {
    __typename: 'OrganizationsConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'Organization';
      id: string;
      name: string;
      createdAt: string;
    }> | null;
  } | null;
};

export type GetDashboardSubscriptionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  where?: InputMaybe<SubscriptionFilterInput>;
}>;

export type GetDashboardSubscriptionsQuery = {
  __typename: 'Query';
  subscriptions: {
    __typename: 'SubscriptionsConnection';
    totalCount: number;
    nodes: Array<{ __typename: 'Subscription'; id: string; state: SubscriptionState }> | null;
  } | null;
};

export type GetDashboardAccountingDocumentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type GetDashboardAccountingDocumentsQuery = {
  __typename: 'Query';
  accountingDocuments: {
    __typename: 'AccountingDocumentsConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'AccountingDocument';
      id: string;
      type: AccountingDocumentType;
      state: AccountingDocumentState;
      amountGross: number;
      createdAt: string;
    }> | null;
  } | null;
};

export type GetDashboardPaymentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type GetDashboardPaymentsQuery = {
  __typename: 'Query';
  payments: {
    __typename: 'PaymentsConnection';
    totalCount: number;
    nodes: Array<{ __typename: 'Payment'; id: string; state: PaymentState }> | null;
  } | null;
};

export type GetDashboardLicencesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  where?: InputMaybe<LicenceFilterInput>;
}>;

export type GetDashboardLicencesQuery = {
  __typename: 'Query';
  licences: {
    __typename: 'LicencesConnection';
    totalCount: number;
    nodes: Array<{ __typename: 'Licence'; id: string }> | null;
  } | null;
};

export type GlobalSearchQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orgWhere?: InputMaybe<OrganizationFilterInput>;
  subWhere?: InputMaybe<SubscriptionFilterInput>;
  licWhere?: InputMaybe<LicenceFilterInput>;
  contactWhere?: InputMaybe<OrganizationContactFilterInput>;
  addrWhere?: InputMaybe<OrganizationAddressFilterInput>;
}>;

export type GlobalSearchQuery = {
  __typename: 'Query';
  organizations: {
    __typename: 'OrganizationsConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'Organization';
      id: string;
      name: string;
      tenant: { __typename: 'Tenant'; id: string; name: string };
    }> | null;
  } | null;
  subscriptions: {
    __typename: 'SubscriptionsConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'Subscription';
      id: string;
      number: string;
      tenant: { __typename: 'Tenant'; id: string; name: string };
      organizationUnit: { __typename: 'OrganizationUnit'; id: string; name: string };
    }> | null;
  } | null;
  licences: {
    __typename: 'LicencesConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'Licence';
      id: string;
      serial: string;
      tenant: { __typename: 'Tenant'; id: string; name: string };
      organizationUnit: { __typename: 'OrganizationUnit'; id: string; name: string } | null;
    }> | null;
  } | null;
  organizationContacts: {
    __typename: 'OrganizationContactsConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'OrganizationContact';
      id: string;
      firstName: string | null;
      lastName: string | null;
      email: string | null;
      organization: { __typename: 'Organization'; id: string; name: string };
      tenant: { __typename: 'Tenant'; id: string; name: string };
    }> | null;
  } | null;
  organizationAddresses: {
    __typename: 'OrganizationAddressesConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'OrganizationAddress';
      id: string;
      phoneNumber: string | null;
      addressLine1: string | null;
      city: string | null;
      zipCode: string | null;
      organization: { __typename: 'Organization'; id: string; name: string };
      tenant: { __typename: 'Tenant'; id: string; name: string };
    }> | null;
  } | null;
};

export type GetPaymentAccountsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type GetPaymentAccountsQuery = {
  __typename: 'Query';
  paymentAccounts: {
    __typename: 'PaymentAccountsConnection';
    totalCount: number;
    nodes: Array<{
      __typename: 'PaymentAccount';
      id: string;
      createdAt: string;
      updatedAt: string;
      paymentGateway: {
        __typename: 'PaymentGateway';
        id: string;
        name: string;
        isActive: boolean;
        isDefault: boolean;
      } | null;
      paymentMethod: {
        __typename: 'PaymentMethodInfo';
        bankName: string | null;
        ending: string | null;
        kind: string | null;
        mandateId: string | null;
        token: string | null;
      } | null;
      organizationUnits: Array<{ __typename: 'OrganizationUnit'; id: string; name: string }>;
      subscriptions: Array<{
        __typename: 'Subscription';
        id: string;
        number: string;
        state: SubscriptionState;
      }>;
    }> | null;
    pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; endCursor: string | null };
  } | null;
};

export type GetSubscriptionQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetSubscriptionQuery = {
  __typename: 'Query';
  subscription: {
    __typename: 'Subscription';
    id: string;
    tenantId: string;
    number: string;
    state: SubscriptionState;
    intervalMonths: number;
    amountNet: number | null;
    amountGross: number | null;
    currencyCode: string | null;
    activationDate: string | null;
    cancellationDate: string | null;
    expiryDate: string | null;
    currentTermStartDate: string | null;
    currentTermEndDate: string | null;
    createdAt: string;
    updatedAt: string | null;
    plan: { __typename: 'Plan'; id: string; name: string };
    organizationUnit: { __typename: 'OrganizationUnit'; id: string; name: string };
    paymentAccount: {
      __typename: 'PaymentAccount';
      id: string;
      paymentMethod: {
        __typename: 'PaymentMethodInfo';
        bankName: string | null;
        ending: string | null;
        kind: string | null;
        mandateId: string | null;
        token: string | null;
      } | null;
      paymentGateway: { __typename: 'PaymentGateway'; id: string; name: string } | null;
      paymentTerm: { __typename: 'PaymentTerm'; id: string; name: string } | null;
    } | null;
    subscriptionItems: Array<{
      __typename: 'SubscriptionItem';
      id: string;
      quantity: number;
      unitPriceNet: number;
      unitPriceGross: number;
    }>;
  } | null;
};

export type GetAccountingDocumentQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetAccountingDocumentQuery = {
  __typename: 'Query';
  accountingDocument: {
    __typename: 'AccountingDocument';
    id: string;
    tenantId: string;
    type: AccountingDocumentType;
    number: string;
    state: AccountingDocumentState;
    currencyCode: string;
    amountNet: number;
    amountGross: number;
    taxAmount: number;
    createdAt: string;
    updatedAt: string | null;
    sentAt: string | null;
    documentHeader: string | null;
    documentFooter: string | null;
    privateNotice: string | null;
    publicNotice: string | null;
    pdfDataBase64: string | null;
    tenant: { __typename: 'Tenant'; id: string; name: string };
    subscription: {
      __typename: 'Subscription';
      id: string;
      number: string;
      organizationUnit: {
        __typename: 'OrganizationUnit';
        organization: { __typename: 'Organization'; id: string; name: string };
      };
    } | null;
    items: Array<{
      __typename: 'AccountingDocumentItem';
      id: string;
      name: string;
      quantity: number;
      unitPriceNet: number;
      unitPriceGross: number;
      amountNet: number;
      amountGross: number;
    }>;
    payments: Array<{
      __typename: 'Payment';
      id: string;
      state: PaymentState;
      direction: PaymentDirection;
      amountGross: number;
      paymentDate: string | null;
      createdAt: string;
      paymentGateway: { __typename: 'PaymentGateway'; id: string; name: string } | null;
    }>;
  } | null;
};

export type GetPaymentQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetPaymentQuery = {
  __typename: 'Query';
  payment: {
    __typename: 'Payment';
    id: string;
    accountingDocumentId: string | null;
    state: PaymentState;
    direction: PaymentDirection;
    amountNet: number;
    amountGross: number;
    currencyCode: string | null;
    reference: string | null;
    paymentDate: string | null;
    createdAt: string;
    updatedAt: string | null;
    accountingDocument: {
      __typename: 'AccountingDocument';
      id: string;
      number: string;
      tenantId: string;
      type: AccountingDocumentType;
      state: AccountingDocumentState;
      amountGross: number;
      tenant: { __typename: 'Tenant'; id: string; name: string };
      subscription: {
        __typename: 'Subscription';
        organizationUnit: {
          __typename: 'OrganizationUnit';
          organization: { __typename: 'Organization'; id: string; name: string };
        };
      } | null;
    } | null;
    paymentGateway: { __typename: 'PaymentGateway'; id: string; name: string } | null;
    paymentHistories: Array<{
      __typename: 'PaymentHistory';
      id: string;
      eventType: PaymentEventType;
      fromState: PaymentState | null;
      toState: PaymentState | null;
      reason: string | null;
      errorMessage: string | null;
      providerEventId: string | null;
      additionalPropertiesJson: string | null;
      createdAt: string;
      updatedAt: string | null;
    }>;
  } | null;
};

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetOrganizationQuery = {
  __typename: 'Query';
  organization: {
    __typename: 'Organization';
    id: string;
    tenantId: string;
    name: string;
    description: string | null;
    status: OrganizationStatus;
    isDefault: boolean;
    type: string | null;
    customerNumber: string;
    createdAt: string;
    updatedAt: string;
    tenant: { __typename: 'Tenant'; id: string; name: string; resellerId: number | null };
    units: Array<{
      __typename: 'OrganizationUnit';
      id: string;
      name: string;
      description: string | null;
      sort: number;
      createdAt: string;
      updatedAt: string;
    }>;
    addresses: Array<{
      __typename: 'OrganizationAddress';
      id: string;
      type: AddressType;
      isDefault: boolean;
      addressLine1: string | null;
      addressLine2: string | null;
      city: string | null;
      zipCode: string | null;
      country: string | null;
      phoneNumber: string | null;
      email: string | null;
      organizationUnit: { __typename: 'OrganizationUnit'; id: string; name: string } | null;
    }>;
    contacts: Array<{
      __typename: 'OrganizationContact';
      id: string;
      firstName: string | null;
      lastName: string | null;
      email: string | null;
      position: string | null;
      salutation: string | null;
    }>;
  } | null;
};

export type GetPaymentAccountQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetPaymentAccountQuery = {
  __typename: 'Query';
  paymentAccount: {
    __typename: 'PaymentAccount';
    id: string;
    tenantId: string;
    createdAt: string;
    updatedAt: string;
    paymentMethod: {
      __typename: 'PaymentMethodInfo';
      bankName: string | null;
      ending: string | null;
      kind: string | null;
      mandateId: string | null;
      token: string | null;
    } | null;
    tenant: { __typename: 'Tenant'; id: string; name: string };
    paymentGateway: {
      __typename: 'PaymentGateway';
      id: string;
      name: string;
      isActive: boolean;
      isDefault: boolean;
      provider: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    paymentTerm: {
      __typename: 'PaymentTerm';
      id: string;
      name: string;
      isActive: boolean;
      isDefault: boolean;
      days: number;
      createdAt: string;
      updatedAt: string;
    } | null;
    organizationUnits: Array<{
      __typename: 'OrganizationUnit';
      id: string;
      name: string;
      description: string | null;
      sort: number;
      createdAt: string;
    }>;
    subscriptions: Array<{
      __typename: 'Subscription';
      id: string;
      number: string;
      state: SubscriptionState;
      amountGross: number | null;
      currencyCode: string | null;
      activationDate: string | null;
      currentTermEndDate: string | null;
    }>;
  } | null;
};

export type GetLicenceQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetLicenceQuery = {
  __typename: 'Query';
  licence: {
    __typename: 'Licence';
    id: string;
    tenantId: string;
    organizationUnitId: string | null;
    databaseId: string | null;
    subscriptionItemId: string | null;
    serial: string;
    appName: string;
    appVersion: number;
    appType: AppType;
    appReglevel: number;
    state: LicenceState;
    type: LicenceType;
    registrationDate: string | null;
    expirationDate: string | null;
    deviceUid: string | null;
    deviceBrand: string | null;
    deviceModel: string | null;
    deviceOS: string | null;
    deviceInfo: string | null;
    deviceDetails: string | null;
    additionalPropertiesJson: string | null;
    createdAt: string;
    updatedAt: string;
    tenant: { __typename: 'Tenant'; id: string; name: string };
    organizationUnit: {
      __typename: 'OrganizationUnit';
      id: string;
      name: string;
      description: string | null;
      organization: { __typename: 'Organization'; id: string; name: string };
    } | null;
    subscriptionItem: {
      __typename: 'SubscriptionItem';
      id: string;
      quantity: number;
      unitPriceNet: number;
      unitPriceGross: number;
      currencyCode: string | null;
      subscription: {
        __typename: 'Subscription';
        id: string;
        number: string;
        state: SubscriptionState;
        plan: { __typename: 'Plan'; id: string; name: string };
        organizationUnit: {
          __typename: 'OrganizationUnit';
          name: string;
          organization: { __typename: 'Organization'; id: string; name: string };
        };
      };
    } | null;
  } | null;
};

export type GetCurrentTenantQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentTenantQuery = {
  __typename: 'Query';
  currentTenant: {
    __typename: 'Tenant';
    id: string;
    name: string;
    resellerLogo: string | null;
    type: TenantType;
    resellerId: number | null;
  } | null;
};

export const ResourceFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewBase64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSizeBytes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceFieldsFragment, unknown>;
export const InvitationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvitationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Invitation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientTenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'respondedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InvitationFieldsFragment, unknown>;
export const GetOrganizationUnitsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOrganizationUnits' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrganizationUnitFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationUnits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'organizationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'branchType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrganizationUnitsQuery, GetOrganizationUnitsQueryVariables>;
export const GetOrganizationUnitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOrganizationUnit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationUnit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'branchType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalPropertiesJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'databaseId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrganizationUnitQuery, GetOrganizationUnitQueryVariables>;
export const GetOrganizationsForAddressListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOrganizationsForAddressList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addresses' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organization' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tenant' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationUnit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOrganizationsForAddressListQuery,
  GetOrganizationsForAddressListQueryVariables
>;
export const GetOrganizationAddressesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOrganizationAddresses' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'OrganizationAddressFilterInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationAddresses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organizationUnit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrganizationAddressesQuery, GetOrganizationAddressesQueryVariables>;
export const GetOrganizationAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOrganizationAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationUnitId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizationUnit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrganizationAddressQuery, GetOrganizationAddressQueryVariables>;
export const GetOrganizationContactsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOrganizationContacts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'OrganizationContactFilterInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationContacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'salutation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrganizationContactsQuery, GetOrganizationContactsQueryVariables>;
export const GetOrganizationContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOrganizationContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'salutation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrganizationContactQuery, GetOrganizationContactQueryVariables>;
export const GetPaymentGatewaysListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPaymentGatewaysList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentGatewayFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentGateways' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaymentGatewaysListQuery, GetPaymentGatewaysListQueryVariables>;
export const GetPaymentGatewayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPaymentGateway' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentGateway' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaymentGatewayQuery, GetPaymentGatewayQueryVariables>;
export const GetPaymentTermsListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPaymentTermsList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentTermFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentTerms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'days' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaymentTermsListQuery, GetPaymentTermsListQueryVariables>;
export const GetPaymentTermDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPaymentTerm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentTerm' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'days' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaymentTermQuery, GetPaymentTermQueryVariables>;
export const GetPlansListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPlansList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PlanFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'plans' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contractTermMonths' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountNet' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountGross' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPlansListQuery, GetPlansListQueryVariables>;
export const GetPlanDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPlanDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'plan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contractTermMonths' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountNet' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountGross' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skus' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPlanDetailQuery, GetPlanDetailQueryVariables>;
export const GetProductsListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetProductsList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'products' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProductsListQuery, GetProductsListQueryVariables>;
export const GetProductDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetProductDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'product' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProductDetailQuery, GetProductDetailQueryVariables>;
export const GetTaxRulesListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTaxRulesList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TaxRuleFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taxRules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'printText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTaxRulesListQuery, GetTaxRulesListQueryVariables>;
export const GetTaxRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTaxRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taxRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taxRate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                { kind: 'Field', name: { kind: 'Name', value: 'printText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTaxRuleQuery, GetTaxRuleQueryVariables>;
export const CreateOrganizationUnitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateOrganizationUnit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateOrganizationUnitInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createOrganizationUnit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizationUnit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'branchType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'additionalPropertiesJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'databaseId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrganizationUnitMutation,
  CreateOrganizationUnitMutationVariables
>;
export const UpdateOrganizationUnitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateOrganizationUnit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateOrganizationUnitInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateOrganizationUnit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizationUnit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'branchType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'additionalPropertiesJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'databaseId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOrganizationUnitMutation,
  UpdateOrganizationUnitMutationVariables
>;
export const DeleteOrganizationUnitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteOrganizationUnit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteOrganizationUnitInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteOrganizationUnit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'boolean' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteOrganizationUnitMutation,
  DeleteOrganizationUnitMutationVariables
>;
export const CreateOrganizationAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateOrganizationAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateOrganizationAddressInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createOrganizationAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizationAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'organizationUnitId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrganizationAddressMutation,
  CreateOrganizationAddressMutationVariables
>;
export const UpdateOrganizationAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateOrganizationAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateOrganizationAddressInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateOrganizationAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizationAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'organizationUnitId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOrganizationAddressMutation,
  UpdateOrganizationAddressMutationVariables
>;
export const DeleteOrganizationAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteOrganizationAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteOrganizationAddressInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteOrganizationAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'boolean' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteOrganizationAddressMutation,
  DeleteOrganizationAddressMutationVariables
>;
export const CreateOrganizationContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateOrganizationContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateOrganizationContactInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createOrganizationContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizationContact' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'salutation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrganizationContactMutation,
  CreateOrganizationContactMutationVariables
>;
export const UpdateOrganizationContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateOrganizationContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateOrganizationContactInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateOrganizationContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizationContact' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'salutation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'organizationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOrganizationContactMutation,
  UpdateOrganizationContactMutationVariables
>;
export const DeleteOrganizationContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteOrganizationContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteOrganizationContactInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteOrganizationContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'boolean' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteOrganizationContactMutation,
  DeleteOrganizationContactMutationVariables
>;
export const CreatePaymentGatewayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePaymentGateway' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePaymentGatewayInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPaymentGateway' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentGateway' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePaymentGatewayMutation, CreatePaymentGatewayMutationVariables>;
export const UpdatePaymentGatewayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePaymentGateway' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePaymentGatewayInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePaymentGateway' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentGateway' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePaymentGatewayMutation, UpdatePaymentGatewayMutationVariables>;
export const DeletePaymentGatewayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeletePaymentGateway' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeletePaymentGatewayInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePaymentGateway' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'boolean' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePaymentGatewayMutation, DeletePaymentGatewayMutationVariables>;
export const CreatePaymentTermDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePaymentTerm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePaymentTermInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPaymentTerm' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentTerm' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'days' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePaymentTermMutation, CreatePaymentTermMutationVariables>;
export const UpdatePaymentTermDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePaymentTerm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePaymentTermInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePaymentTerm' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentTerm' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'days' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePaymentTermMutation, UpdatePaymentTermMutationVariables>;
export const DeletePaymentTermDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeletePaymentTerm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeletePaymentTermInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePaymentTerm' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'boolean' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePaymentTermMutation, DeletePaymentTermMutationVariables>;
export const CreatePlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePlanInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'plan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contractTermMonths' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountNet' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountGross' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePlanMutation, CreatePlanMutationVariables>;
export const UpdatePlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePlanInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'plan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountNet' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountGross' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contractTermMonths' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePlanMutation, UpdatePlanMutationVariables>;
export const CreateProductDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateProduct' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateProductInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createProduct' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateProductMutation, CreateProductMutationVariables>;
export const UpdateProductDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateProduct' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateProductInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProduct' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateProductMutation, UpdateProductMutationVariables>;
export const CreateTaxRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTaxRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateTaxRuleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTaxRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taxRule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'printText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTaxRuleMutation, CreateTaxRuleMutationVariables>;
export const UpdateTaxRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTaxRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateTaxRuleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTaxRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taxRule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'printText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTaxRuleMutation, UpdateTaxRuleMutationVariables>;
export const DeleteTaxRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteTaxRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteTaxRuleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTaxRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'boolean' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTaxRuleMutation, DeleteTaxRuleMutationVariables>;
export const GetAppVersionsListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAppVersionsList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppVersionFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appVersions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'versionName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'versionCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'releaseNotes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'releaseDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAppVersionsListQuery, GetAppVersionsListQueryVariables>;
export const GetAppVersionDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAppVersionDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appVersion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'versionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'versionCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'releaseNotes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'releaseDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAppVersionDetailQuery, GetAppVersionDetailQueryVariables>;
export const GetAppVersionPolicyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAppVersionPolicy' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appVersionPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'requiredMinVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suggestedMinVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updateStoreUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAppVersionPolicyQuery, GetAppVersionPolicyQueryVariables>;
export const CreateAppVersionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateAppVersion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateAppVersionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAppVersion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'versionName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'versionCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'releaseNotes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'releaseDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateAppVersionMutation, CreateAppVersionMutationVariables>;
export const UpdateAppVersionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAppVersion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateAppVersionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAppVersion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'versionName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'versionCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'releaseNotes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'releaseDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAppVersionMutation, UpdateAppVersionMutationVariables>;
export const DeleteAppVersionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteAppVersion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteAppVersionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAppVersion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'boolean' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteAppVersionMutation, DeleteAppVersionMutationVariables>;
export const UpdateAppVersionPolicyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAppVersionPolicy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateAppVersionPolicyInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAppVersionPolicy' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appVersionPolicy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'requiredMinVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'suggestedMinVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updateStoreUrl' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAppVersionPolicyMutation,
  UpdateAppVersionPolicyMutationVariables
>;
export const UpdateTenantDiscountPercentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTenantDiscountPercent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTenantDiscountPercentInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTenantDiscountPercent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'discountPercent' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTenantDiscountPercentMutation,
  UpdateTenantDiscountPercentMutationVariables
>;
export const UpdateTenantResellerLogoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTenantResellerLogo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTenantResellerLogoInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTenantResellerLogo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resellerLogo' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'EntityNotFoundError' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'InvalidOperationError' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTenantResellerLogoMutation,
  UpdateTenantResellerLogoMutationVariables
>;
export const CreateProvisionPayoutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateProvisionPayout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateProvisionPayoutInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createProvisionPayout' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountingDocument' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountNet' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountGross' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateProvisionPayoutMutation, CreateProvisionPayoutMutationVariables>;
export const GetCouponsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCoupons' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CouponFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coupons' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'discountType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'discountValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'usageType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxRedemptions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'redemptionCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowedPlanCodes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowedProductSkus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCouponsQuery, GetCouponsQueryVariables>;
export const GetAvailableCouponsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAvailableCoupons' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CouponFilterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'CouponSortInput' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableCoupons' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'discountType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'discountValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxRedemptions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'redemptionCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowedPlanCodes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowedProductSkus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAvailableCouponsQuery, GetAvailableCouponsQueryVariables>;
export const GetCouponDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCoupon' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coupon' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'discountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'discountValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'usageType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxRedemptions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'redemptionCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowedPlanCodes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowedProductSkus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCouponQuery, GetCouponQueryVariables>;
export const CreateCouponDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCoupon' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateCouponInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCoupon' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coupon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCouponMutation, CreateCouponMutationVariables>;
export const UpdateCouponDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCoupon' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateCouponInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCoupon' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coupon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCouponMutation, UpdateCouponMutationVariables>;
export const DeleteCouponDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteCoupon' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteCouponInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCoupon' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'boolean' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCouponMutation, DeleteCouponMutationVariables>;
export const MainCouponDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MainCoupon' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mainCoupon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'discountPercent' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MainCouponQuery, MainCouponQueryVariables>;
export const UpdateMainCouponDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateMainCoupon' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateMainCouponInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMainCoupon' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'boolean' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMainCouponMutation, UpdateMainCouponMutationVariables>;
export const DeleteMainCouponDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteMainCoupon' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteMainCoupon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'boolean' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteMainCouponMutation, DeleteMainCouponMutationVariables>;
export const GetResourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetResources' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resources' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewBase64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSizeBytes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetResourcesQuery, GetResourcesQueryVariables>;
export const GetResourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetResource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentBase64' } },
                { kind: 'Field', name: { kind: 'Name', value: 'previewBase64' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileSizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetResourceQuery, GetResourceQueryVariables>;
export const CreateResourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateResource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateResourceInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createResource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceFields' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'InvalidOperationError' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewBase64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSizeBytes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateResourceMutation, CreateResourceMutationVariables>;
export const UpdateResourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateResource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateResourceInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateResource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceFields' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'EntityNotFoundError' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'InvalidOperationError' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewBase64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSizeBytes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateResourceMutation, UpdateResourceMutationVariables>;
export const DeleteResourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteResource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteResourceInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteResource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'boolean' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'EntityNotFoundError' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteResourceMutation, DeleteResourceMutationVariables>;
export const ReorderResourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReorderResources' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ReorderResourcesInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reorderResources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceFields' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'EntityNotFoundError' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewBase64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSizeBytes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReorderResourcesMutation, ReorderResourcesMutationVariables>;
export const GetInvitationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetInvitations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'InvitationFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'invitations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InvitationFields' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvitationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Invitation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientTenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'respondedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetInvitationsQuery, GetInvitationsQueryVariables>;
export const CreateInvitationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateInvitation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateInvitationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createInvitation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'invitation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InvitationFields' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvitationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Invitation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientTenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'respondedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateInvitationMutation, CreateInvitationMutationVariables>;
export const ResendInvitationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResendInvitation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResendInvitationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resendInvitation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'invitation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InvitationFields' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvitationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Invitation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientTenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'respondedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResendInvitationMutation, ResendInvitationMutationVariables>;
export const MarkInvitationFailedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MarkInvitationFailed' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarkInvitationFailedInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markInvitationFailed' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'invitation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InvitationFields' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvitationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Invitation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientTenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'respondedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarkInvitationFailedMutation, MarkInvitationFailedMutationVariables>;
export const RevokeInvitationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RevokeInvitation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RevokeInvitationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revokeInvitation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'boolean' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RevokeInvitationMutation, RevokeInvitationMutationVariables>;
export const UpdateLicenceStateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateLicenceState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateLicenceStateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLicenceState' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licence' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'EntityNotFoundError' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateLicenceStateMutation, UpdateLicenceStateMutationVariables>;
export const CreateOrganizationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateOrganization' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateOrganizationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createOrganization' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const UpdateOrganizationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateOrganization' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateOrganizationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateOrganization' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'EntityNotFoundError' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const GetUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUser' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'sub' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'givenName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'familyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resellerId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const GetTenantsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTenants' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resellerId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TenantFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tenants' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resellerId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resellerId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tenantNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resellerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'discountPercent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTenantsQuery, GetTenantsQueryVariables>;
export const GetTenantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTenant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tenant' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resellerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'discountPercent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTenantQuery, GetTenantQueryVariables>;
export const GetSubscriptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSubscriptions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubscriptionFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subscriptions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'intervalMonths' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountNet' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountGross' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activationDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cancellationDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentTermStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentTermEndDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'plan' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organizationUnit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subscriptionItems' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPriceNet' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPriceGross' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>;
export const GetAccountingDocumentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAccountingDocuments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resellerTenantId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'AccountingDocumentFilterInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountingDocuments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resellerTenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resellerTenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountNet' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountGross' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'additionalPropertiesJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pdfDataBase64' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subscription' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationUnit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'organization' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPriceNet' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPriceGross' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'amountNet' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'amountGross' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAccountingDocumentsQuery, GetAccountingDocumentsQueryVariables>;
export const GetPaymentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPayments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'accountingDocumentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountNet' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountGross' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paymentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountingDocument' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tenant' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subscription' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'organizationUnit' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'organization' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'id' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentGateway' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaymentsQuery, GetPaymentsQueryVariables>;
export const GetLicencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetLicences' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'databaseId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'LicenceFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'licences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'databaseId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'databaseId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'organizationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'organizationUnitId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'databaseId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subscriptionItemId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serial' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appReglevel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'registrationDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceUid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceBrand' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceOS' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceInfo' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceDetails' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'additionalPropertiesJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organizationUnit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subscriptionItem' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLicencesQuery, GetLicencesQueryVariables>;
export const GetOrganizationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOrganizations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrganizationFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'customerNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resellerId' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetDashboardOrganizationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDashboardOrganizations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrganizationFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetDashboardOrganizationsQuery,
  GetDashboardOrganizationsQueryVariables
>;
export const GetDashboardSubscriptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDashboardSubscriptions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubscriptionFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subscriptions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetDashboardSubscriptionsQuery,
  GetDashboardSubscriptionsQueryVariables
>;
export const GetDashboardAccountingDocumentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDashboardAccountingDocuments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountingDocuments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountGross' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetDashboardAccountingDocumentsQuery,
  GetDashboardAccountingDocumentsQueryVariables
>;
export const GetDashboardPaymentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDashboardPayments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDashboardPaymentsQuery, GetDashboardPaymentsQueryVariables>;
export const GetDashboardLicencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDashboardLicences' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'databaseId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'LicenceFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'licences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'databaseId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'databaseId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'organizationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDashboardLicencesQuery, GetDashboardLicencesQueryVariables>;
export const GlobalSearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GlobalSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orgWhere' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrganizationFilterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subWhere' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubscriptionFilterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'licWhere' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'LicenceFilterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactWhere' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'OrganizationContactFilterInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'addrWhere' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'OrganizationAddressFilterInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orgWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subscriptions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organizationUnit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'licences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'licWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serial' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organizationUnit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationContacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contactWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizationAddresses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'addrWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GlobalSearchQuery, GlobalSearchQueryVariables>;
export const GetPaymentAccountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPaymentAccounts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentAccounts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentGateway' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentMethod' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'bankName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ending' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'mandateId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organizationUnits' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subscriptions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaymentAccountsQuery, GetPaymentAccountsQueryVariables>;
export const GetSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'intervalMonths' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountNet' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountGross' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cancellationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentTermStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentTermEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'plan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizationUnit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentMethod' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'bankName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ending' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'mandateId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentGateway' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentTerm' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subscriptionItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unitPriceNet' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unitPriceGross' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSubscriptionQuery, GetSubscriptionQueryVariables>;
export const GetAccountingDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAccountingDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountingDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountNet' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountGross' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taxAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentHeader' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentFooter' } },
                { kind: 'Field', name: { kind: 'Name', value: 'privateNotice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicNotice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pdfDataBase64' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subscription' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organizationUnit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organization' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unitPriceNet' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unitPriceGross' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountNet' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountGross' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountGross' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paymentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentGateway' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAccountingDocumentQuery, GetAccountingDocumentQueryVariables>;
export const GetPaymentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPayment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountingDocumentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountNet' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountGross' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountingDocument' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountGross' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subscription' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationUnit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'organization' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentGateway' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentHistories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'providerEventId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'additionalPropertiesJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaymentQuery, GetPaymentQueryVariables>;
export const GetOrganizationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOrganization' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organization' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customerNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resellerId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'units' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organizationUnit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contacts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'salutation' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const GetPaymentAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPaymentAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentAccount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentMethod' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bankName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ending' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mandateId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentGateway' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentTerm' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'days' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizationUnits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subscriptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountGross' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activationDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentTermEndDate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPaymentAccountQuery, GetPaymentAccountQueryVariables>;
export const GetLicenceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetLicence' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'licence' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationUnitId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'databaseId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscriptionItemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serial' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appReglevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'registrationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceUid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceBrand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceOS' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceInfo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalPropertiesJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizationUnit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subscriptionItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unitPriceNet' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unitPriceGross' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subscription' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'plan' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationUnit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'organization' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLicenceQuery, GetLicenceQueryVariables>;
export const GetCurrentTenantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCurrentTenant' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentTenant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resellerLogo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resellerId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCurrentTenantQuery, GetCurrentTenantQueryVariables>;
